var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var defineProperty$b = {exports: {}};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$d =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var fails$f = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$e = fails$f;

var functionBindNative = !fails$e(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var FunctionPrototype$3 = Function.prototype;
var apply$2 = FunctionPrototype$3.apply;
var call$9 = FunctionPrototype$3.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$3 ? call$9.bind(apply$2) : function () {
  return call$9.apply(apply$2, arguments);
});

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$8 = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$8, call$8);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$8.apply(fn, arguments);
  };
};

var uncurryThis$i = functionUncurryThis;

var toString$7 = uncurryThis$i({}.toString);
var stringSlice$1 = uncurryThis$i(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$1(toString$7(it), 8, -1);
};

var classofRaw$1 = classofRaw$2;
var uncurryThis$h = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw$1(fn) === 'Function') return uncurryThis$h(fn);
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$f = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var objectGetOwnPropertyDescriptor = {};

var fails$d = fails$f;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$d(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var NATIVE_BIND$1 = functionBindNative;

var call$7 = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$7.bind(call$7) : function () {
  return call$7.apply(call$7, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable$1 = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable$1.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$1;

var createPropertyDescriptor$5 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var uncurryThis$g = functionUncurryThis;
var fails$c = fails$f;
var classof$7 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$g(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$c(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$7(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$1 = isNullOrUndefined$2;

var $TypeError$6 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$3 = function (it) {
  if (isNullOrUndefined$1(it)) throw new $TypeError$6("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$2 = requireObjectCoercible$3;

var toIndexedObject$7 = function (it) {
  return IndexedObject$1(requireObjectCoercible$2(it));
};

var isCallable$e = isCallable$f;

var isObject$9 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$e(it);
};

var path$5 = {};

var path$4 = path$5;
var global$c = global$d;
var isCallable$d = isCallable$f;

var aFunction = function (variable) {
  return isCallable$d(variable) ? variable : undefined;
};

var getBuiltIn$9 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path$4[namespace]) || aFunction(global$c[namespace])
    : path$4[namespace] && path$4[namespace][method] || global$c[namespace] && global$c[namespace][method];
};

var uncurryThis$f = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$f({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$b = global$d;
var userAgent = engineUserAgent;

var process = global$b.process;
var Deno = global$b.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$2 = engineV8Version;
var fails$b = fails$f;
var global$a = global$d;

var $String$4 = global$a.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$b(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$4(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$2 && V8_VERSION$2 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$5 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$5
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$8 = getBuiltIn$9;
var isCallable$c = isCallable$f;
var isPrototypeOf$1 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$5 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$8('Symbol');
  return isCallable$c($Symbol) && isPrototypeOf$1($Symbol.prototype, $Object$3(it));
};

var $String$3 = String;

var tryToString$2 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$b = isCallable$f;
var tryToString$1 = tryToString$2;

var $TypeError$5 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$2 = function (argument) {
  if (isCallable$b(argument)) return argument;
  throw new $TypeError$5(tryToString$1(argument) + ' is not a function');
};

var aCallable$1 = aCallable$2;
var isNullOrUndefined = isNullOrUndefined$2;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable$1(func);
};

var call$6 = functionCall;
var isCallable$a = isCallable$f;
var isObject$8 = isObject$9;

var $TypeError$4 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$a(fn = input.toString) && !isObject$8(val = call$6(fn, input))) return val;
  if (isCallable$a(fn = input.valueOf) && !isObject$8(val = call$6(fn, input))) return val;
  if (pref !== 'string' && isCallable$a(fn = input.toString) && !isObject$8(val = call$6(fn, input))) return val;
  throw new $TypeError$4("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var global$9 = global$d;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$a = Object.defineProperty;

var defineGlobalProperty$1 = function (key, value) {
  try {
    defineProperty$a(global$9, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$9[key] = value;
  } return value;
};

var globalThis$1 = global$d;
var defineGlobalProperty = defineGlobalProperty$1;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$1[SHARED] || defineGlobalProperty(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.37.0',
  mode: 'pure' ,
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.37.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var sharedStoreExports = sharedStore.exports;

var store$2 = sharedStoreExports;

var shared$7 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$1 = requireObjectCoercible$3;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$5 = function (argument) {
  return $Object$2(requireObjectCoercible$1(argument));
};

var uncurryThis$e = functionUncurryThis;
var toObject$4 = toObject$5;

var hasOwnProperty = uncurryThis$e({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$4(it), key);
};

var uncurryThis$d = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$6 = uncurryThis$d(1.0.toString);

var uid$3 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$6(++id + postfix, 36);
};

var global$8 = global$d;
var shared$6 = shared$7;
var hasOwn$b = hasOwnProperty_1;
var uid$2 = uid$3;
var NATIVE_SYMBOL$4 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$3 = global$8.Symbol;
var WellKnownSymbolsStore$2 = shared$6('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$3['for'] || Symbol$3 : Symbol$3 && Symbol$3.withoutSetter || uid$2;

var wellKnownSymbol$e = function (name) {
  if (!hasOwn$b(WellKnownSymbolsStore$2, name)) {
    WellKnownSymbolsStore$2[name] = NATIVE_SYMBOL$4 && hasOwn$b(Symbol$3, name)
      ? Symbol$3[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore$2[name];
};

var call$5 = functionCall;
var isObject$7 = isObject$9;
var isSymbol$4 = isSymbol$5;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$d = wellKnownSymbol$e;

var $TypeError$3 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$d('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$7 = function (input, pref) {
  if (!isObject$7(input) || isSymbol$4(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$5(exoticToPrim, input, pref);
    if (!isObject$7(result) || isSymbol$4(result)) return result;
    throw new $TypeError$3("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive$6 = toPrimitive$7;
var isSymbol$3 = isSymbol$5;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$4 = function (argument) {
  var key = toPrimitive$6(argument, 'string');
  return isSymbol$3(key) ? key : key + '';
};

var global$7 = global$d;
var isObject$6 = isObject$9;

var document$1 = global$7.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$6(document$1) && isObject$6(document$1.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$9 = descriptors;
var fails$a = fails$f;
var createElement = documentCreateElement$1;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$9 && !fails$a(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$8 = descriptors;
var call$4 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$4 = createPropertyDescriptor$5;
var toIndexedObject$6 = toIndexedObject$7;
var toPropertyKey$3 = toPropertyKey$4;
var hasOwn$a = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$8 ? $getOwnPropertyDescriptor$2 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$6(O);
  P = toPropertyKey$3(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$2(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$a(O, P)) return createPropertyDescriptor$4(!call$4(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var fails$9 = fails$f;
var isCallable$9 = isCallable$f;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$9(detection) ? fails$9(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var uncurryThis$c = functionUncurryThisClause;
var aCallable = aCallable$2;
var NATIVE_BIND = functionBindNative;

var bind$2 = uncurryThis$c(uncurryThis$c.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$2(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var objectDefineProperty = {};

var DESCRIPTORS$7 = descriptors;
var fails$8 = fails$f;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$7 && fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$5 = isObject$9;

var $String$2 = String;
var $TypeError$2 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$4 = function (argument) {
  if (isObject$5(argument)) return argument;
  throw new $TypeError$2($String$2(argument) + ' is not an object');
};

var DESCRIPTORS$6 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$3 = anObject$4;
var toPropertyKey$2 = toPropertyKey$4;

var $TypeError$1 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty$1 = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$6 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$3(O);
  P = toPropertyKey$2(P);
  anObject$3(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty$1(O, P, Attributes);
} : $defineProperty$1 : function defineProperty(O, P, Attributes) {
  anObject$3(O);
  P = toPropertyKey$2(P);
  anObject$3(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty$1(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$1('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$5 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$5;

var createNonEnumerableProperty$4 = DESCRIPTORS$5 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$3(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var global$6 = global$d;
var apply$1 = functionApply;
var uncurryThis$b = functionUncurryThisClause;
var isCallable$8 = isCallable$f;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var isForced = isForced_1;
var path$3 = path$5;
var bind$1 = functionBindContext;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var hasOwn$9 = hasOwnProperty_1;
// add debugging info


var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof Wrapper) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return apply$1(NativeConstructor, this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global$6 : STATIC ? global$6[TARGET] : global$6[TARGET] && global$6[TARGET].prototype;

  var target = GLOBAL ? path$3 : path$3[TARGET] || createNonEnumerableProperty$3(path$3, TARGET, {})[TARGET];
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && hasOwn$9(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (!FORCED && !PROTO && typeof targetProperty == typeof sourceProperty) continue;

    // bind methods to global for calling from export context
    if (options.bind && USE_NATIVE) resultProperty = bind$1(sourceProperty, global$6);
    // wrap global constructors for prevent changes in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && isCallable$8(sourceProperty)) resultProperty = uncurryThis$b(sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(resultProperty, 'sham', true);
    }

    createNonEnumerableProperty$3(target, key, resultProperty);

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!hasOwn$9(path$3, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty$3(path$3, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      createNonEnumerableProperty$3(path$3[VIRTUAL_PROTOTYPE], key, sourceProperty);
      // export real prototype methods
      if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) {
        createNonEnumerableProperty$3(targetPrototype, key, sourceProperty);
      }
    }
  }
};

var $$b = _export;
var DESCRIPTORS$4 = descriptors;
var defineProperty$9 = objectDefineProperty.f;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$$b({ target: 'Object', stat: true, forced: Object.defineProperty !== defineProperty$9, sham: !DESCRIPTORS$4 }, {
  defineProperty: defineProperty$9
});

var path$2 = path$5;

var Object$1 = path$2.Object;

var defineProperty$8 = defineProperty$b.exports = function defineProperty(it, key, desc) {
  return Object$1.defineProperty(it, key, desc);
};

if (Object$1.defineProperty.sham) defineProperty$8.sham = true;

var definePropertyExports = defineProperty$b.exports;

var parent$b = definePropertyExports;

var defineProperty$7 = parent$b;

var parent$a = defineProperty$7;

var defineProperty$6 = parent$a;

var parent$9 = defineProperty$6;

var defineProperty$5 = parent$9;

var defineProperty$4 = defineProperty$5;

var _Object$defineProperty = /*@__PURE__*/getDefaultExportFromCjs(defineProperty$4);

var classof$6 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$4 = Array.isArray || function isArray(argument) {
  return classof$6(argument) === 'Array';
};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$3 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$3;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  var len = toIntegerOrInfinity$2(argument);
  return len > 0 ? min$1(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$3 = function (obj) {
  return toLength(obj.length);
};

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$1 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$5;

var createProperty$1 = function (object, key, value) {
  if (DESCRIPTORS$3) definePropertyModule$2.f(object, key, createPropertyDescriptor$2(0, value));
  else object[key] = value;
};

var wellKnownSymbol$c = wellKnownSymbol$e;

var TO_STRING_TAG$2 = wellKnownSymbol$c('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var isCallable$7 = isCallable$f;
var classofRaw = classofRaw$2;
var wellKnownSymbol$b = wellKnownSymbol$e;

var TO_STRING_TAG$1 = wellKnownSymbol$b('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$5 = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable$7(O.callee) ? 'Arguments' : result;
};

var uncurryThis$a = functionUncurryThis;
var isCallable$6 = isCallable$f;
var store$1 = sharedStoreExports;

var functionToString = uncurryThis$a(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$6(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var uncurryThis$9 = functionUncurryThis;
var fails$7 = fails$f;
var isCallable$5 = isCallable$f;
var classof$4 = classof$5;
var getBuiltIn$7 = getBuiltIn$9;
var inspectSource = inspectSource$1;

var noop$2 = function () { /* empty */ };
var construct = getBuiltIn$7('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$1 = uncurryThis$9(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop$2);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  try {
    construct(noop$2, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  switch (classof$4(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$7(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isArray$3 = isArray$4;
var isConstructor = isConstructor$1;
var isObject$4 = isObject$9;
var wellKnownSymbol$a = wellKnownSymbol$e;

var SPECIES$1 = wellKnownSymbol$a('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray$3(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray$3(C.prototype))) C = undefined;
    else if (isObject$4(C)) {
      C = C[SPECIES$1];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$2 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var fails$6 = fails$f;
var wellKnownSymbol$9 = wellKnownSymbol$e;
var V8_VERSION$1 = engineV8Version;

var SPECIES = wellKnownSymbol$9('species');

var arrayMethodHasSpeciesSupport$1 = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION$1 >= 51 || !fails$6(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var $$a = _export;
var fails$5 = fails$f;
var isArray$2 = isArray$4;
var isObject$3 = isObject$9;
var toObject$3 = toObject$5;
var lengthOfArrayLike$2 = lengthOfArrayLike$3;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$1;
var createProperty = createProperty$1;
var arraySpeciesCreate$1 = arraySpeciesCreate$2;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$1;
var wellKnownSymbol$8 = wellKnownSymbol$e;
var V8_VERSION = engineV8Version;

var IS_CONCAT_SPREADABLE = wellKnownSymbol$8('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails$5(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject$3(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray$2(O);
};

var FORCED$1 = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$$a({ target: 'Array', proto: true, arity: 1, forced: FORCED$1 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject$3(this);
    var A = arraySpeciesCreate$1(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike$2(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

var classof$3 = classof$5;

var $String$1 = String;

var toString$5 = function (argument) {
  if (classof$3(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

var objectDefineProperties = {};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$3;

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var toIndexedObject$5 = toIndexedObject$7;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$3;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$5($this);
    var length = lengthOfArrayLike$1(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var hiddenKeys$5 = {};

var uncurryThis$8 = functionUncurryThis;
var hasOwn$8 = hasOwnProperty_1;
var toIndexedObject$4 = toIndexedObject$7;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$4 = hiddenKeys$5;

var push$3 = uncurryThis$8([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$4(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$8(hiddenKeys$4, key) && hasOwn$8(O, key) && push$3(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$8(O, key = names[i++])) {
    ~indexOf(result, key) || push$3(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};

var DESCRIPTORS$2 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$1 = objectDefineProperty;
var anObject$2 = anObject$4;
var toIndexedObject$3 = toIndexedObject$7;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$2 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$2(O);
  var props = toIndexedObject$3(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$1.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$6 = getBuiltIn$9;

var html$1 = getBuiltIn$6('document', 'documentElement');

var shared$5 = shared$7;
var uid$1 = uid$3;

var keys = shared$5('keys');

var sharedKey$4 = function (key) {
  return keys[key] || (keys[key] = uid$1(key));
};

/* global ActiveXObject -- old IE, WSH */
var anObject$1 = anObject$4;
var definePropertiesModule$1 = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$3 = hiddenKeys$5;
var html = html$1;
var documentCreateElement = documentCreateElement$1;
var sharedKey$3 = sharedKey$4;

var GT = '>';
var LT = '<';
var PROTOTYPE$1 = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$3('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE$1][enumBugKeys$1[length]];
  return NullProtoObject();
};

hiddenKeys$3[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$1] = anObject$1(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule$1.f(result, Properties);
};

var objectGetOwnPropertyNames = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;

var hiddenKeys$2 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys$2);
};

var objectGetOwnPropertyNamesExternal = {};

var uncurryThis$7 = functionUncurryThis;

var arraySlice$2 = uncurryThis$7([].slice);

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof$2 = classofRaw$2;
var toIndexedObject$2 = toIndexedObject$7;
var $getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var arraySlice$1 = arraySlice$2;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames$1(it);
  } catch (error) {
    return arraySlice$1(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
  return windowNames && classof$2(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames$1(toIndexedObject$2(it));
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;

var defineBuiltIn$4 = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty$2(target, key, value);
  return target;
};

var defineProperty$3 = objectDefineProperty;

var defineBuiltInAccessor$1 = function (target, name, descriptor) {
  return defineProperty$3.f(target, name, descriptor);
};

var wellKnownSymbolWrapped = {};

var wellKnownSymbol$7 = wellKnownSymbol$e;

wellKnownSymbolWrapped.f = wellKnownSymbol$7;

var path$1 = path$5;
var hasOwn$7 = hasOwnProperty_1;
var wrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
var defineProperty$2 = objectDefineProperty.f;

var wellKnownSymbolDefine = function (NAME) {
  var Symbol = path$1.Symbol || (path$1.Symbol = {});
  if (!hasOwn$7(Symbol, NAME)) defineProperty$2(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule$1.f(NAME)
  });
};

var call$3 = functionCall;
var getBuiltIn$5 = getBuiltIn$9;
var wellKnownSymbol$6 = wellKnownSymbol$e;
var defineBuiltIn$3 = defineBuiltIn$4;

var symbolDefineToPrimitive = function () {
  var Symbol = getBuiltIn$5('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol$6('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn$3(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call$3(valueOf, this);
    }, { arity: 1 });
  }
};

var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$1 = classof$5;

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
  return '[object ' + classof$1(this) + ']';
};

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var defineProperty$1 = objectDefineProperty.f;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var hasOwn$6 = hasOwnProperty_1;
var toString$4 = objectToString;
var wellKnownSymbol$5 = wellKnownSymbol$e;

var TO_STRING_TAG = wellKnownSymbol$5('toStringTag');

var setToStringTag$6 = function (it, TAG, STATIC, SET_METHOD) {
  var target = STATIC ? it : it && it.prototype;
  if (target) {
    if (!hasOwn$6(target, TO_STRING_TAG)) {
      defineProperty$1(target, TO_STRING_TAG, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !TO_STRING_TAG_SUPPORT) {
      createNonEnumerableProperty$1(target, 'toString', toString$4);
    }
  }
};

var global$5 = global$d;
var isCallable$4 = isCallable$f;

var WeakMap$1 = global$5.WeakMap;

var weakMapBasicDetection = isCallable$4(WeakMap$1) && /native code/.test(String(WeakMap$1));

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$4 = global$d;
var isObject$2 = isObject$9;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var hasOwn$5 = hasOwnProperty_1;
var shared$4 = sharedStoreExports;
var sharedKey$2 = sharedKey$4;
var hiddenKeys$1 = hiddenKeys$5;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$4.TypeError;
var WeakMap = global$4.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$4.state) {
  var store = shared$4.state || (shared$4.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$1[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$5(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$5(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$5(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var bind = functionBindContext;
var uncurryThis$6 = functionUncurryThis;
var IndexedObject = indexedObject;
var toObject$2 = toObject$5;
var lengthOfArrayLike = lengthOfArrayLike$3;
var arraySpeciesCreate = arraySpeciesCreate$2;

var push$2 = uncurryThis$6([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$2($this);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(self);
    var boundFunction = bind(callbackfn, that);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push$2(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push$2(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$1(7)
};

var $$9 = _export;
var global$3 = global$d;
var call$2 = functionCall;
var uncurryThis$5 = functionUncurryThis;
var DESCRIPTORS$1 = descriptors;
var NATIVE_SYMBOL$3 = symbolConstructorDetection;
var fails$4 = fails$f;
var hasOwn$4 = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var anObject = anObject$4;
var toIndexedObject$1 = toIndexedObject$7;
var toPropertyKey$1 = toPropertyKey$4;
var $toString = toString$5;
var createPropertyDescriptor$1 = createPropertyDescriptor$5;
var nativeObjectCreate = objectCreate;
var objectKeys = objectKeys$2;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternal = objectGetOwnPropertyNamesExternal;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;
var definePropertiesModule = objectDefineProperties;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var defineBuiltIn$2 = defineBuiltIn$4;
var defineBuiltInAccessor = defineBuiltInAccessor$1;
var shared$3 = shared$7;
var sharedKey$1 = sharedKey$4;
var hiddenKeys = hiddenKeys$5;
var uid = uid$3;
var wellKnownSymbol$4 = wellKnownSymbol$e;
var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
var defineWellKnownSymbol$m = wellKnownSymbolDefine;
var defineSymbolToPrimitive$1 = symbolDefineToPrimitive;
var setToStringTag$5 = setToStringTag$6;
var InternalStateModule$2 = internalState;
var $forEach = arrayIteration.forEach;

var HIDDEN = sharedKey$1('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState$2 = InternalStateModule$2.set;
var getInternalState$2 = InternalStateModule$2.getterFor(SYMBOL);

var ObjectPrototype$1 = Object[PROTOTYPE];
var $Symbol = global$3.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var RangeError = global$3.RangeError;
var TypeError$1 = global$3.TypeError;
var QObject = global$3.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push$1 = uncurryThis$5([].push);

var AllSymbols = shared$3('symbols');
var ObjectPrototypeSymbols = shared$3('op-symbols');
var WellKnownSymbolsStore$1 = shared$3('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var fallbackDefineProperty = function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype$1, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$1[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$1) {
    nativeDefineProperty(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
  }
};

var setSymbolDescriptor = DESCRIPTORS$1 && fails$4(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a !== 7;
}) ? fallbackDefineProperty : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState$2(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS$1) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype$1) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey$1(P);
  anObject(Attributes);
  if (hasOwn$4(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn$4(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor$1(1, nativeObjectCreate(null)));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn$4(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor$1(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject$1(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS$1 || call$2($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey$1(V);
  var enumerable = call$2(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype$1 && hasOwn$4(AllSymbols, P) && !hasOwn$4(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn$4(this, P) || !hasOwn$4(AllSymbols, P) || hasOwn$4(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject$1(O);
  var key = toPropertyKey$1(P);
  if (it === ObjectPrototype$1 && hasOwn$4(AllSymbols, key) && !hasOwn$4(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn$4(AllSymbols, key) && !(hasOwn$4(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject$1(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn$4(AllSymbols, key) && !hasOwn$4(hiddenKeys, key)) push$1(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject$1(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn$4(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn$4(ObjectPrototype$1, key))) {
      push$1(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL$3) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError$1('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      var $this = this === undefined ? global$3 : this;
      if ($this === ObjectPrototype$1) call$2(setter, ObjectPrototypeSymbols, value);
      if (hasOwn$4($this, HIDDEN) && hasOwn$4($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
      var descriptor = createPropertyDescriptor$1(1, value);
      try {
        setSymbolDescriptor($this, tag, descriptor);
      } catch (error) {
        if (!(error instanceof RangeError)) throw error;
        fallbackDefineProperty($this, tag, descriptor);
      }
    };
    if (DESCRIPTORS$1 && USE_SETTER) setSymbolDescriptor(ObjectPrototype$1, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn$2(SymbolPrototype, 'toString', function toString() {
    return getInternalState$2(this).tag;
  });

  defineBuiltIn$2($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule$1.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol$4(name), name);
  };

  if (DESCRIPTORS$1) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$2(this).description;
      }
    });
  }
}

$$9({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL$3, sham: !NATIVE_SYMBOL$3 }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore$1), function (name) {
  defineWellKnownSymbol$m(name);
});

$$9({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL$3 }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$$9({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL$3, sham: !DESCRIPTORS$1 }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$$9({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL$3 }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive$1();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag$5($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;

var NATIVE_SYMBOL$2 = symbolConstructorDetection;

/* eslint-disable es/no-symbol -- safe */
var symbolRegistryDetection = NATIVE_SYMBOL$2 && !!Symbol['for'] && !!Symbol.keyFor;

var $$8 = _export;
var getBuiltIn$4 = getBuiltIn$9;
var hasOwn$3 = hasOwnProperty_1;
var toString$3 = toString$5;
var shared$2 = shared$7;
var NATIVE_SYMBOL_REGISTRY$1 = symbolRegistryDetection;

var StringToSymbolRegistry = shared$2('string-to-symbol-registry');
var SymbolToStringRegistry$1 = shared$2('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$$8({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY$1 }, {
  'for': function (key) {
    var string = toString$3(key);
    if (hasOwn$3(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn$4('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry$1[symbol] = string;
    return symbol;
  }
});

var $$7 = _export;
var hasOwn$2 = hasOwnProperty_1;
var isSymbol$2 = isSymbol$5;
var tryToString = tryToString$2;
var shared$1 = shared$7;
var NATIVE_SYMBOL_REGISTRY = symbolRegistryDetection;

var SymbolToStringRegistry = shared$1('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$$7({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol$2(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn$2(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});

var uncurryThis$4 = functionUncurryThis;
var isArray$1 = isArray$4;
var isCallable$3 = isCallable$f;
var classof = classofRaw$2;
var toString$2 = toString$5;

var push = uncurryThis$4([].push);

var getJsonReplacerFunction = function (replacer) {
  if (isCallable$3(replacer)) return replacer;
  if (!isArray$1(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString$2(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray$1(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};

var $$6 = _export;
var getBuiltIn$3 = getBuiltIn$9;
var apply = functionApply;
var call$1 = functionCall;
var uncurryThis$3 = functionUncurryThis;
var fails$3 = fails$f;
var isCallable$2 = isCallable$f;
var isSymbol$1 = isSymbol$5;
var arraySlice = arraySlice$2;
var getReplacerFunction = getJsonReplacerFunction;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var $String = String;
var $stringify = getBuiltIn$3('JSON', 'stringify');
var exec = uncurryThis$3(/./.exec);
var charAt$2 = uncurryThis$3(''.charAt);
var charCodeAt$1 = uncurryThis$3(''.charCodeAt);
var replace = uncurryThis$3(''.replace);
var numberToString = uncurryThis$3(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL$1 || fails$3(function () {
  var symbol = getBuiltIn$3('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails$3(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable$2($replacer) && (it === undefined || isSymbol$1(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable$2($replacer)) value = call$1($replacer, this, $String(key), value);
    if (!isSymbol$1(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt$2(string, offset - 1);
  var next = charAt$2(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt$1(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $$6({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}

var $$5 = _export;
var NATIVE_SYMBOL = symbolConstructorDetection;
var fails$2 = fails$f;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var toObject$1 = toObject$5;

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails$2(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$$5({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject$1(it)) : [];
  }
});

var defineWellKnownSymbol$l = wellKnownSymbolDefine;

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol$l('asyncIterator');

var defineWellKnownSymbol$k = wellKnownSymbolDefine;

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol$k('hasInstance');

var defineWellKnownSymbol$j = wellKnownSymbolDefine;

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol$j('isConcatSpreadable');

var defineWellKnownSymbol$i = wellKnownSymbolDefine;

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol$i('iterator');

var defineWellKnownSymbol$h = wellKnownSymbolDefine;

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol$h('match');

var defineWellKnownSymbol$g = wellKnownSymbolDefine;

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol$g('matchAll');

var defineWellKnownSymbol$f = wellKnownSymbolDefine;

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol$f('replace');

var defineWellKnownSymbol$e = wellKnownSymbolDefine;

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol$e('search');

var defineWellKnownSymbol$d = wellKnownSymbolDefine;

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol$d('species');

var defineWellKnownSymbol$c = wellKnownSymbolDefine;

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol$c('split');

var defineWellKnownSymbol$b = wellKnownSymbolDefine;
var defineSymbolToPrimitive = symbolDefineToPrimitive;

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol$b('toPrimitive');

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

var getBuiltIn$2 = getBuiltIn$9;
var defineWellKnownSymbol$a = wellKnownSymbolDefine;
var setToStringTag$4 = setToStringTag$6;

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol$a('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag$4(getBuiltIn$2('Symbol'), 'Symbol');

var defineWellKnownSymbol$9 = wellKnownSymbolDefine;

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol$9('unscopables');

var global$2 = global$d;
var setToStringTag$3 = setToStringTag$6;

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag$3(global$2.JSON, 'JSON', true);

var path = path$5;

var symbol$4 = path.Symbol;

var iterators = {};

var DESCRIPTORS = descriptors;
var hasOwn$1 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$1(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var fails$1 = fails$f;

var correctPrototypeGetter = !fails$1(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn = hasOwnProperty_1;
var isCallable$1 = isCallable$f;
var toObject = toObject$5;
var sharedKey = sharedKey$4;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$1(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var fails = fails$f;
var isCallable = isCallable$f;
var isObject$1 = isObject$9;
var create$1 = objectCreate;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$1 = defineBuiltIn$4;
var wellKnownSymbol$3 = wellKnownSymbol$e;

var ITERATOR$1 = wellKnownSymbol$3('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$1, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$1 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$1(IteratorPrototype$1) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$1[ITERATOR$1].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$1 = {};
else IteratorPrototype$1 = create$1(IteratorPrototype$1);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype$1[ITERATOR$1])) {
  defineBuiltIn$1(IteratorPrototype$1, ITERATOR$1, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$1,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$5;
var setToStringTag$2 = setToStringTag$6;
var Iterators$3 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators$3[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$4 = _export;
var call = functionCall;
var FunctionName = functionName;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setToStringTag$1 = setToStringTag$6;
var defineBuiltIn = defineBuiltIn$4;
var wellKnownSymbol$2 = wellKnownSymbol$e;
var Iterators$2 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
FunctionName.CONFIGURABLE;
IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol$2('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      Iterators$2[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$4({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators$2[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$2 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$7;
var Iterators$1 = iterators;
var InternalStateModule$1 = internalState;
objectDefineProperty.f;
var defineIterator$1 = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$2;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
defineIterator$1(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject$1(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject$1(index, false);
    case 'values': return createIterResultObject$1(target[index], false);
  } return createIterResultObject$1([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators$1.Arguments = Iterators$1.Array;

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var DOMIterables = domIterables;
var global$1 = global$d;
var setToStringTag = setToStringTag$6;
var Iterators = iterators;

for (var COLLECTION_NAME in DOMIterables) {
  setToStringTag(global$1[COLLECTION_NAME], COLLECTION_NAME);
  Iterators[COLLECTION_NAME] = Iterators.Array;
}

var parent$8 = symbol$4;


var symbol$3 = parent$8;

var wellKnownSymbol$1 = wellKnownSymbol$e;
var defineProperty = objectDefineProperty.f;

var METADATA = wellKnownSymbol$1('metadata');
var FunctionPrototype = Function.prototype;

// Function.prototype[@@metadata]
// https://github.com/tc39/proposal-decorator-metadata
if (FunctionPrototype[METADATA] === undefined) {
  defineProperty(FunctionPrototype, METADATA, {
    value: null
  });
}

var defineWellKnownSymbol$8 = wellKnownSymbolDefine;

// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
defineWellKnownSymbol$8('asyncDispose');

var defineWellKnownSymbol$7 = wellKnownSymbolDefine;

// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
defineWellKnownSymbol$7('dispose');

var defineWellKnownSymbol$6 = wellKnownSymbolDefine;

// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
defineWellKnownSymbol$6('metadata');

var parent$7 = symbol$3;






var symbol$2 = parent$7;

var getBuiltIn$1 = getBuiltIn$9;
var uncurryThis$2 = functionUncurryThis;

var Symbol$2 = getBuiltIn$1('Symbol');
var keyFor = Symbol$2.keyFor;
var thisSymbolValue$1 = uncurryThis$2(Symbol$2.prototype.valueOf);

// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
var symbolIsRegistered = Symbol$2.isRegisteredSymbol || function isRegisteredSymbol(value) {
  try {
    return keyFor(thisSymbolValue$1(value)) !== undefined;
  } catch (error) {
    return false;
  }
};

var $$3 = _export;
var isRegisteredSymbol$1 = symbolIsRegistered;

// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$$3({ target: 'Symbol', stat: true }, {
  isRegisteredSymbol: isRegisteredSymbol$1
});

var shared = shared$7;
var getBuiltIn = getBuiltIn$9;
var uncurryThis$1 = functionUncurryThis;
var isSymbol = isSymbol$5;
var wellKnownSymbol = wellKnownSymbol$e;

var Symbol$1 = getBuiltIn('Symbol');
var $isWellKnownSymbol = Symbol$1.isWellKnownSymbol;
var getOwnPropertyNames = getBuiltIn('Object', 'getOwnPropertyNames');
var thisSymbolValue = uncurryThis$1(Symbol$1.prototype.valueOf);
var WellKnownSymbolsStore = shared('wks');

for (var i$1 = 0, symbolKeys = getOwnPropertyNames(Symbol$1), symbolKeysLength = symbolKeys.length; i$1 < symbolKeysLength; i$1++) {
  // some old engines throws on access to some keys like `arguments` or `caller`
  try {
    var symbolKey = symbolKeys[i$1];
    if (isSymbol(Symbol$1[symbolKey])) wellKnownSymbol(symbolKey);
  } catch (error) { /* empty */ }
}

// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
var symbolIsWellKnown = function isWellKnownSymbol(value) {
  if ($isWellKnownSymbol && $isWellKnownSymbol(value)) return true;
  try {
    var symbol = thisSymbolValue(value);
    for (var j = 0, keys = getOwnPropertyNames(WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++) {
      // eslint-disable-next-line eqeqeq -- polyfilled symbols case
      if (WellKnownSymbolsStore[keys[j]] == symbol) return true;
    }
  } catch (error) { /* empty */ }
  return false;
};

var $$2 = _export;
var isWellKnownSymbol$1 = symbolIsWellKnown;

// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$$2({ target: 'Symbol', stat: true, forced: true }, {
  isWellKnownSymbol: isWellKnownSymbol$1
});

var defineWellKnownSymbol$5 = wellKnownSymbolDefine;

// `Symbol.customMatcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol$5('customMatcher');

var defineWellKnownSymbol$4 = wellKnownSymbolDefine;

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol$4('observable');

var $$1 = _export;
var isRegisteredSymbol = symbolIsRegistered;

// `Symbol.isRegistered` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$$1({ target: 'Symbol', stat: true, name: 'isRegisteredSymbol' }, {
  isRegistered: isRegisteredSymbol
});

var $ = _export;
var isWellKnownSymbol = symbolIsWellKnown;

// `Symbol.isWellKnown` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$({ target: 'Symbol', stat: true, name: 'isWellKnownSymbol', forced: true }, {
  isWellKnown: isWellKnownSymbol
});

var defineWellKnownSymbol$3 = wellKnownSymbolDefine;

// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol$3('matcher');

// TODO: Remove from `core-js@4`
var defineWellKnownSymbol$2 = wellKnownSymbolDefine;

// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
defineWellKnownSymbol$2('metadataKey');

// TODO: remove from `core-js@4`
var defineWellKnownSymbol$1 = wellKnownSymbolDefine;

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol$1('patternMatch');

// TODO: remove from `core-js@4`
var defineWellKnownSymbol = wellKnownSymbolDefine;

defineWellKnownSymbol('replaceAll');

var parent$6 = symbol$2;




// TODO: Remove from `core-js@4`







var symbol$1 = parent$6;

var symbol = symbol$1;

var _Symbol = /*@__PURE__*/getDefaultExportFromCjs(symbol);

var uncurryThis = functionUncurryThis;
var toIntegerOrInfinity = toIntegerOrInfinity$3;
var toString$1 = toString$5;
var requireObjectCoercible = requireObjectCoercible$3;

var charAt$1 = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$1(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$1(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt = stringMultibyte.charAt;
var toString = toString$5;
var InternalStateModule = internalState;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$2;

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});

var WrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;

var iterator$4 = WrappedWellKnownSymbolModule$1.f('iterator');

var parent$5 = iterator$4;


var iterator$3 = parent$5;

var parent$4 = iterator$3;

var iterator$2 = parent$4;

var parent$3 = iterator$2;

var iterator$1 = parent$3;

var iterator = iterator$1;

var _Symbol$iterator = /*@__PURE__*/getDefaultExportFromCjs(iterator);

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof _Symbol && o.constructor === _Symbol && o !== _Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

var WrappedWellKnownSymbolModule = wellKnownSymbolWrapped;

var toPrimitive$5 = WrappedWellKnownSymbolModule.f('toPrimitive');

var parent$2 = toPrimitive$5;

var toPrimitive$4 = parent$2;

var parent$1 = toPrimitive$4;

var toPrimitive$3 = parent$1;

var parent = toPrimitive$3;

var toPrimitive$2 = parent;

var toPrimitive$1 = toPrimitive$2;

var _Symbol$toPrimitive = /*@__PURE__*/getDefaultExportFromCjs(toPrimitive$1);

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[_Symbol$toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const uuidRegex = new RegExp("^".concat(UUID, "$"), 'i');
const hasTrim = !!String.prototype.trim;
function onNonNull(value, fn) {
  return value != null ? fn(value) : value;
}
function safeToString(value) {
  return typeof value === 'object' ? JSON.stringify(value) : '' + value;
}
function nonNull(value) {
  return value != null;
}
function isUUID(value) {
  return !!value && uuidRegex.test(trim(value));
}
function isArray(arr) {
  return Object.prototype.toString.call(arr) === '[object Array]';
}
function trim(value) {
  return hasTrim ? ('' + value).trim() : ('' + value).replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
function isString(str) {
  return typeof str === 'string';
}
function strEqualsIgnoreCase(fistStr, secondStr) {
  return isString(fistStr) && isString(secondStr) && trim(fistStr.toLowerCase()) === trim(secondStr.toLowerCase());
}
function isObject(obj) {
  return !!obj && typeof obj === 'object' && !isArray(obj);
}
function isRecord(obj) {
  return isObject(obj);
}
function isFunction(fun) {
  return !!fun && typeof fun === 'function';
}
function _expiresIn(expires, number) {
  return new Date(new Date().getTime() + expires * number);
}
function expiresInDays(expires) {
  return _expiresIn(expires, 864e5);
}
function wrapError(name, e, message) {
  if (isObject(e)) {
    let error;
    if ('message' in e && typeof e.message === 'string') {
      error = new Error(message || e.message);
    } else {
      error = new Error(message);
    }
    error.name = name;
    if ('stack' in e && typeof e.stack === 'string') {
      error.stack = e.stack;
    }
    if ('lineNumber' in e && typeof e.lineNumber === 'number') {
      error.lineNumber = e.lineNumber;
    }
    if ('columnNumber' in e && typeof e.columnNumber === 'number') {
      error.columnNumber = e.columnNumber;
    }
    return error;
  } else {
    const error = Error(message);
    error.name = name;
    return error;
  }
}
const ERRORS_CHANNEL = 'li_errors';
class ReplayEmitter {
  constructor(replaySize) {
    _defineProperty(this, "data", void 0);
    const size = parseInt(replaySize.toString()) || 5;
    this.data = {
      h: {},
      q: {},
      size
    };
  }
  on(name, callback, ctx) {
    const handler = {
      callback: callback.bind(ctx),
      unbound: callback
    };
    this.data = {
      ...this.data,
      h: {
        ...this.data.h,
        [name]: [...(this.data.h[name] || []), handler]
      }
    };
    (this.data.q[name] || []).forEach(i => callback.call(ctx, i));
    return this;
  }
  once(name, callback, ctx) {
    const eventQueue = this.data.q[name] || [];
    if (eventQueue.length > 0) {
      callback.call(ctx, eventQueue[0]);
      return this;
    } else {
      const listener = args => {
        this.off(name, listener);
        callback.call(ctx, args);
      };
      listener._ = callback;
      return this.on(name, listener, ctx);
    }
  }
  emit(name, event) {
    (this.data.h[name] || []).forEach(i => i.callback(event));
    const queue = this.data.q[name] || [];
    this.data = {
      ...this.data,
      q: {
        ...this.data.q,
        [name]: [...(queue.length < this.data.size ? queue : queue.slice(1)), event]
      }
    };
    return this;
  }
  off(name, callback) {
    const handlers = this.data.h[name];
    const liveHandlers = handlers && callback && handlers.filter(h => h.unbound !== callback) || [];
    if (liveHandlers.length) {
      this.data = {
        ...this.data,
        h: {
          ...this.data.h,
          [name]: liveHandlers
        }
      };
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const {
        [name]: _,
        ...rest
      } = this.data.h;
      this.data = {
        ...this.data,
        h: rest
      };
    }
    return this;
  }
  emitErrorWithMessage(name, message, exception) {
    const wrappedError = wrapError(name, exception, message);
    return this.emit(ERRORS_CHANNEL, wrappedError);
  }
  emitError(name, exception) {
    const wrappedError = wrapError(name, exception);
    return this.emit(ERRORS_CHANNEL, wrappedError);
  }
}
const DEFAULT_AJAX_TIMEOUT = 0;
const DEFAULT_AJAX_RETRIES = 3;
class PixelSender {
  constructor(opts) {
    var _opts$collectorUrl, _opts$ajaxTimeout, _opts$ajaxRetries;
    _defineProperty(this, "url", void 0);
    _defineProperty(this, "timeout", void 0);
    _defineProperty(this, "calls", void 0);
    _defineProperty(this, "eventBus", void 0);
    _defineProperty(this, "retries", void 0);
    this.url = (_opts$collectorUrl = opts.collectorUrl) !== null && _opts$collectorUrl !== void 0 ? _opts$collectorUrl : 'https://rp.liadm.com';
    this.timeout = (_opts$ajaxTimeout = opts.ajaxTimeout) !== null && _opts$ajaxTimeout !== void 0 ? _opts$ajaxTimeout : DEFAULT_AJAX_TIMEOUT;
    this.calls = opts.callHandler;
    this.eventBus = opts.eventBus;
    this.retries = (_opts$ajaxRetries = opts.ajaxRetries) !== null && _opts$ajaxRetries !== void 0 ? _opts$ajaxRetries : DEFAULT_AJAX_RETRIES;
  }
  callBakers(bakersJson) {
    try {
      const bakers = JSON.parse(bakersJson).bakers;
      if (isArray(bakers)) {
        for (let i = 0; i < bakers.length; i++) this.calls.pixelGet("".concat(bakers[i], "?dtstmp=").concat(Date.now()));
      }
    } catch (e) {
      this.eventBus.emitErrorWithMessage('CallBakers', "Error while calling bakers with ".concat(bakersJson), e);
    }
  }
  sendState(state, endpoint, makeCall, onPreSend) {
    if (state.sendsPixel()) {
      if (onPreSend && isFunction(onPreSend)) {
        onPreSend();
      }
      const query = state.asQuery().add('dtstmp', Date.now(), {
        prepend: true
      }).toQueryString();
      const uri = "".concat(this.url, "/").concat(endpoint).concat(query);
      makeCall(uri);
    }
  }
  sendAjax(state) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.sendState(state, 'j', uri => {
      const go = remainingRetries => {
        this.calls.ajaxGet(uri, bakersJson => {
          if (opts.onLoad && isFunction(opts.onLoad)) opts.onLoad();
          this.callBakers(bakersJson);
        }, e => {
          if (remainingRetries <= 0) {
            this.sendPixel(state, opts);
            this.eventBus.emitError('AjaxFailed', e);
          } else {
            go(remainingRetries - 1);
          }
        }, this.timeout);
      };
      go(this.retries);
    }, opts.onPreSend);
  }
  sendPixel(state) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.sendState(state, 'p', uri => this.calls.pixelGet(uri, opts.onLoad), opts.onPreSend);
  }
}
const EVENT_BUS_NAMESPACE = '__li__evt_bus';
// reexport for backwards compat
const ERRORS_PREFIX = ERRORS_CHANNEL;
const PIXEL_SENT_PREFIX = 'lips';
const PRELOAD_PIXEL = 'pre_lips';
const PEOPLE_VERIFIED_LS_ENTRY = '_li_duid';
const DEFAULT_IDEX_AJAX_TIMEOUT = 5000;
const DEFAULT_IDEX_URL = 'https://idx.liadm.com/idex';
const DEFAULT_REQUESTED_ATTRIBUTES = []; // legacy behaviour; resolves nonId as unifiedId

var consts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DEFAULT_IDEX_AJAX_TIMEOUT: DEFAULT_IDEX_AJAX_TIMEOUT,
  DEFAULT_IDEX_URL: DEFAULT_IDEX_URL,
  DEFAULT_REQUESTED_ATTRIBUTES: DEFAULT_REQUESTED_ATTRIBUTES,
  ERRORS_PREFIX: ERRORS_PREFIX,
  EVENT_BUS_NAMESPACE: EVENT_BUS_NAMESPACE,
  PEOPLE_VERIFIED_LS_ENTRY: PEOPLE_VERIFIED_LS_ENTRY,
  PIXEL_SENT_PREFIX: PIXEL_SENT_PREFIX,
  PRELOAD_PIXEL: PRELOAD_PIXEL
});

// btoa() as defined by the HTML and Infra specs, which mostly just references RFC 4648.
function btoa(s) {
  // String conversion as required by Web IDL.
  s = "".concat(s);
  // "The btoa() method must throw an "InvalidCharacterError" DOMException if
  // data contains any character whose code point is greater than U+00FF."
  for (let i = 0; i < s.length; i++) {
    if (s.charCodeAt(i) > 255) {
      return null;
    }
  }
  let out = '';
  for (let i = 0; i < s.length; i += 3) {
    const groupsOfSix = [undefined, undefined, undefined, undefined];
    groupsOfSix[0] = s.charCodeAt(i) >> 2;
    groupsOfSix[1] = (s.charCodeAt(i) & 0x03) << 4;
    if (s.length > i + 2) {
      groupsOfSix[1] |= s.charCodeAt(i + 1) >> 4;
      groupsOfSix[2] = (s.charCodeAt(i + 1) & 0x0f) << 2;
      groupsOfSix[2] |= s.charCodeAt(i + 2) >> 6;
      groupsOfSix[3] = s.charCodeAt(i + 2) & 0x3f;
    } else if (s.length > i + 1) {
      groupsOfSix[1] |= s.charCodeAt(i + 1) >> 4;
      groupsOfSix[2] = (s.charCodeAt(i + 1) & 0x0f) << 2;
    }
    for (let j = 0; j < groupsOfSix.length; j++) {
      const element = groupsOfSix[j];
      if (typeof element === 'undefined') {
        out += '=';
      } else {
        out += btoaLookup(element);
      }
    }
  }
  return out;
}
// Lookup table for btoa(), which converts a six-bit number into the corresponding ASCII character.
const keystr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
function btoaLookup(index) {
  return index >= 0 && index < 64 ? keystr[index] : undefined;
}
function _safeBtoa(s) {
  const res = btoa(s);
  return res || '';
}
const _base64encodeRegex = /[+/]|=+$/g;
const _base64ToUrlEncodedChars = {
  '+': '-',
  '/': '_'
};
function _replaceBase64Chars(x) {
  return _base64ToUrlEncodedChars[x] || '';
}
function base64UrlEncode(s) {
  let btoa = null;
  // First we escape the string using encodeURIComponent to get the UTF-8 encoding of the characters,
  // then we convert the percent encodings into raw bytes, and finally feed it to btoa() function.
  const utf8Bytes = encodeURIComponent(s).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(parseInt('0x' + p1, 16)));
  try {
    btoa = window && isFunction(window.btoa) ? window.btoa : _safeBtoa;
  } catch (e) {
    btoa = _safeBtoa;
  }
  return btoa(utf8Bytes).replace(_base64encodeRegex, _replaceBase64Chars);
}
for (var r = [], o = 0; o < 64;) r[o] = 0 | 4294967296 * Math.sin(++o % Math.PI);
function n(n) {
  var t,
    e,
    f,
    a = [t = 1732584193, e = 4023233417, ~t, ~e],
    c = [],
    u = unescape(encodeURI(n)) + "",
    h = u.length;
  for (n = --h / 4 + 2 | 15, c[--n] = 8 * h; ~h;) c[h >> 2] |= u.charCodeAt(h) << 8 * h--;
  for (o = u = 0; o < n; o += 16) {
    for (h = a; u < 64; h = [f = h[3], t + ((f = h[0] + [t & e | ~t & f, f & t | ~f & e, t ^ e ^ f, e ^ (t | ~f)][h = u >> 4] + r[u] + ~~c[o | 15 & [u, 5 * u + 1, 3 * u + 5, 7 * u][h]]) << (h = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21][4 * h + u++ % 4]) | f >>> -h), t, e]) t = 0 | h[1], e = h[2];
    for (u = 4; u;) a[--u] += h[u];
  }
  for (n = ""; u < 32;) n += (a[u >> 3] >> 4 * (1 ^ u++) & 15).toString(16);
  return n;
}
function t(r) {
  var o,
    n,
    t,
    e,
    f,
    a = [],
    c = [n = 1732584193, t = 4023233417, ~n, ~t, 3285377520],
    u = [],
    h = unescape(encodeURI(r)) + "",
    i = h.length;
  for (u[r = --i / 4 + 2 | 15] = 8 * i; ~i;) u[i >> 2] |= h.charCodeAt(i) << 8 * ~i--;
  for (o = i = 0; o < r; o += 16) {
    for (n = c; i < 80; n = [n[4] + (a[i] = i < 16 ? ~~u[o + i] : 2 * h | h < 0) + 1518500249 + [t & e | ~t & f, h = 341275144 + (t ^ e ^ f), 882459459 + (t & e | t & f | e & f), h + 1535694389][i++ / 5 >> 2] + ((h = n[0]) << 5 | h >>> 27), h, t << 30 | t >>> 2, e, f]) h = a[i - 3] ^ a[i - 8] ^ a[i - 14] ^ a[i - 16], t = n[1], e = n[2], f = n[3];
    for (i = 5; i;) c[--i] += n[i];
  }
  for (h = ""; i < 40;) h += (c[i >> 3] >> 4 * (7 - i++) & 15).toString(16);
  return h;
}
for (var e, f = 18, a = [], c = []; f > 1; f--) for (e = f; e < 320;) a[e += f] = 1;
function u(r, o) {
  return 4294967296 * Math.pow(r, 1 / o) | 0;
}
for (e = 0; e < 64;) a[++f] || (c[e] = u(f, 2), a[e++] = u(f, 3));
function h(r, o) {
  return r >>> o | r << -o;
}
function i(r) {
  var o = c.slice(f = e = 0, 8),
    n = [],
    t = unescape(encodeURI(r)) + "",
    i = t.length;
  for (n[r = --i / 4 + 2 | 15] = 8 * i; ~i;) n[i >> 2] |= t.charCodeAt(i) << 8 * ~i--;
  for (i = []; f < r; f += 16) {
    for (u = o.slice(); e < 64; u.unshift(t + (h(t = u[0], 2) ^ h(t, 13) ^ h(t, 22)) + (t & u[1] ^ u[1] & u[2] ^ u[2] & t))) u[3] += t = 0 | (i[e] = e < 16 ? ~~n[e + f] : (h(t = i[e - 2], 17) ^ h(t, 19) ^ t >>> 10) + i[e - 7] + (h(t = i[e - 15], 7) ^ h(t, 18) ^ t >>> 3) + i[e - 16]) + u.pop() + (h(t = u[4], 6) ^ h(t, 11) ^ h(t, 25)) + (t & u[5] ^ ~t & u[6]) + a[e++];
    for (e = 8; e;) o[--e] += u[e];
  }
  for (t = ""; e < 64;) t += (o[e >> 3] >> 4 * (7 - e++) & 15).toString(16);
  return t;
}
const hashLikeRegex = () => /(\s+)?[a-f0-9]{32,64}(\s+)?/gi;
const lengthToHashType = new Map([[32, 'md5'], [40, 'sha1'], [64, 'sha256']]);
function isHash(hash) {
  const extractedHash = extractHashValue(hash);
  return !!extractedHash && lengthToHashType.has(extractedHash.length);
}
function extractHashValue(s) {
  const result = s.match(hashLikeRegex());
  return result && result.map(trim)[0];
}
function hashEmail(email) {
  const lowerCasedEmail = email.toLowerCase();
  return {
    md5: n(lowerCasedEmail),
    sha1: t(lowerCasedEmail),
    sha256: i(lowerCasedEmail)
  };
}
function domainHash(domain) {
  let limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
  return t(domain.replace(/^\./, '')).substring(0, limit);
}
const emailRegex = () => /\S+(@|%40)\S+\.\S+/;
function isEmail(s) {
  return emailRegex().test(s);
}
function containsEmailField(s) {
  return emailRegex().test(s);
}
function extractEmail(s) {
  const result = s.match(emailRegex());
  return result && result.map(trim)[0];
}
function listEmailsInString(s) {
  const result = [];
  // eslint-disable-next-line
  const emailLikeRegex = "([\\w\\d.+-]+(@|%40)[\\w\\d-]+.[\\w\\d.-]+)";
  const multipleEmailLikeRegex = new RegExp(emailLikeRegex, 'g');
  let current = multipleEmailLikeRegex.exec(s);
  while (current) {
    result.push(trim(current[1]));
    current = multipleEmailLikeRegex.exec(s);
  }
  return result;
}
function replaceEmailsWithHashes(originalString) {
  const emailsInString = listEmailsInString(originalString);
  const hashes = [];
  let convertedString = originalString;
  for (let i = 0; i < emailsInString.length; i++) {
    const email = emailsInString[i];
    const emailHashes = hashEmail(email);
    convertedString = convertedString.replace(email, emailHashes.md5);
    hashes.push(emailHashes);
  }
  return {
    stringWithoutRawEmails: convertedString,
    hashesFromOriginalString: hashes
  };
}
const MASK = '*********';
function replacer(key, value) {
  return typeof value === 'string' && isEmail(trim(value)) ? MASK : value;
}
function _isNum(v) {
  return isNaN(+v) ? v : +v;
}
function _isNull(v) {
  return v === 'null' || v === 'undefined' ? null : v;
}
function _isBoolean(v) {
  return v === 'false' ? false : v === 'true' ? true : v;
}
function _convert(v) {
  return _isBoolean(_isNull(_isNum(v)));
}
function _parseParam(params, key) {
  if (key in params) {
    const value = params[key];
    if (isArray(value)) {
      return value.map(v => _convert(decodeValue(v)));
    } else {
      return _convert(decodeValue(value));
    }
  }
}
function _allParams(url) {
  let questionMarkIndex, queryParams, historyIndex;
  const obj = {};
  if (!url || (questionMarkIndex = url.indexOf('?')) === -1 || !(queryParams = url.slice(questionMarkIndex + 1))) {
    return obj;
  }
  if ((historyIndex = queryParams.indexOf('#')) !== -1 && !(queryParams = queryParams.slice(0, historyIndex))) {
    return obj;
  }
  queryParams.split('&').forEach(function (raw) {
    if (raw) {
      let key;
      const split = raw.split('=');
      key = split[0];
      const value = split.length === 2 ? split[1] : 'true';
      if (key.slice(-2) === '[]') {
        key = key.slice(0, -2);
      }
      if (key in obj) {
        const previous = obj[key];
        if (isArray(previous)) {
          previous.push(value);
        } else {
          obj[key] = [previous, value];
        }
      } else {
        obj[key] = value;
      }
    }
  });
  return obj;
}
function decodeValue(v) {
  return v.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
}
function urlParamsArray(url) {
  const params = _allParams(url);
  const result = [];
  Object.keys(params).forEach(k => {
    result.push([k, _parseParam(params, k)]);
  });
  return result;
}
function getQueryParameter(url, name) {
  const params = _allParams(url);
  return _parseParam(params, name);
}
class ParsedUrl {
  constructor(url) {
    _defineProperty(this, "hash", void 0);
    _defineProperty(this, "host", void 0);
    _defineProperty(this, "hostname", void 0);
    _defineProperty(this, "pathname", void 0);
    _defineProperty(this, "port", void 0);
    _defineProperty(this, "protocol", void 0);
    _defineProperty(this, "search", void 0);
    // eslint-disable-next-line
    const urlRegExp = /^(https?\:\/\/)?(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/;
    const match = url.match(urlRegExp);
    if (match === null) {
      throw new TypeError("Failed to parse URL: ".concat(url));
    } else {
      this.protocol = match[1] || '';
      this.host = match[2] || '';
      this.hostname = match[3] || '';
      this.port = match[4] || '';
      this.pathname = match[5] || '';
      this.search = match[6] || '';
      this.hash = match[7] || '';
    }
  }
  toString() {
    return "".concat(this.protocol).concat(this.host).concat(this.pathname).concat(this.search).concat(this.hash);
  }
}
const MAX_ITEMS = 10;
const LIMITING_KEYS = ['items', 'itemids'];
const HASH_BEARERS = ['email', 'emailhash', 'hash', 'hashedemail'];
function provided(state) {
  const eventSource = state.eventSource || {};
  const objectKeys = Object.keys(eventSource);
  for (const key of objectKeys) {
    const lowerCased = key.toLowerCase();
    if (HASH_BEARERS.indexOf(lowerCased) > -1) {
      const value = trim(safeToString(eventSource[key]));
      const extractedEmail = extractEmail(value);
      const extractedHash = extractHashValue(value);
      if (extractedEmail) {
        const hashes = hashEmail(decodeValue(extractedEmail));
        return mergeObjects({
          hashedEmail: [hashes.md5, hashes.sha1, hashes.sha256]
        }, state);
      } else if (extractedHash && isHash(extractedHash)) {
        return mergeObjects({
          hashedEmail: [extractedHash.toLowerCase()]
        }, state);
      }
    }
  }
  return state;
}
function itemsLimiter(state) {
  const event = state.eventSource || {};
  Object.keys(event).forEach(key => {
    const lowerCased = key.toLowerCase();
    const value = event[key];
    if (LIMITING_KEYS.indexOf(lowerCased) > -1 && isArray(value) && value.length > MAX_ITEMS) {
      value.length = MAX_ITEMS;
    }
  });
  return {};
}
const fiddlers = [provided, itemsLimiter];
function fiddle(state) {
  function reducer(accumulator, func) {
    return mergeObjects(accumulator, func(accumulator));
  }
  if (isObject(state.eventSource)) {
    return fiddlers.reduce(reducer, state);
  } else {
    return state;
  }
}
function mergeObjects(obj1, obj2) {
  const res = {};
  function clean(obj) {
    return isObject(obj) ? obj : {};
  }
  function keys(obj) {
    return Object.keys(obj);
  }
  const first = clean(obj1);
  const second = clean(obj2);
  keys(first).forEach(key => {
    res[key] = first[key];
  });
  keys(second).forEach(key => {
    res[key] = second[key];
  });
  return res;
}
class QueryBuilder {
  constructor() {
    let tuples = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _defineProperty(this, "tuples", void 0);
    this.tuples = tuples;
  }
  add(key, value) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const {
      stripEmpty = true,
      prepend = false
    } = options;
    if (key === '') {
      return this;
    } else if (stripEmpty && value === '') {
      return this;
    } else if (prepend) {
      this.tuples.unshift([key, value]);
      return this;
    } else {
      this.tuples.push([key, value]);
      return this;
    }
  }
  addOptional(key, value) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (nonNull(value)) {
      return this.add(key, value, options);
    } else {
      return this;
    }
  }
  addParamsMap(paramsMap) {
    Object.keys(paramsMap).forEach(key => {
      const value = paramsMap[key];
      if (nonNull(value)) {
        if (isArray(value)) {
          value.forEach(entry => this.add(key, entry));
        } else {
          this.add(key, value);
        }
      }
    });
    return this;
  }
  copy() {
    return new QueryBuilder(this.tuples.slice());
  }
  filteredCopy(predicate) {
    return new QueryBuilder(this.tuples.filter(_ref => {
      let [k, v] = _ref;
      return predicate(k, v);
    }));
  }
  toQueryString() {
    let acc = '';
    this.tuples.forEach(_ref2 => {
      let [k, v] = _ref2;
      const operator = acc.length === 0 ? '?' : '&';
      acc = "".concat(acc).concat(operator).concat(encodeURIComponent(k), "=").concat(encodeURIComponent(v));
    });
    return acc;
  }
}
// for use with QueryBuilder#addOptionalParam. Null has a special meaning for the idCookie.
function encodeIdCookie(value) {
  return value === null ? '' : value;
}
const UrlCollectionModes = {
  full: 'full',
  noPath: 'no_path'
};
function collectUrl(state) {
  if (state.pageUrl === undefined || state.pageUrl.length === 0) {
    return ['', false, []];
  }
  if (isDefaultBehavior(state)) {
    return [state.pageUrl, false, []];
  }
  const url = new ParsedUrl(state.pageUrl);
  const urlQueryParameters = urlParamsArray(url.search);
  const pathRemoved = isPathRemoved(url, state);
  const blockedParams = paramsToDelete(urlQueryParameters, state);
  if (pathRemoved) {
    url.pathname = '/';
  }
  if (blockedParams.length > 0) {
    url.search = queryStringToKeep(urlQueryParameters, blockedParams);
  }
  return [url.toString(), pathRemoved, blockedParams];
}
function stripQueryAndPath(pageUrl) {
  if (pageUrl.length === 0) {
    return undefined;
  } else {
    const url = new ParsedUrl(pageUrl);
    url.pathname = '';
    url.search = '';
    return url.toString();
  }
}
function isPathRemoved(url, conf) {
  return conf.urlCollectionMode === UrlCollectionModes.noPath && url.pathname.length > 1;
}
function paramsToDelete(urlQueryParameters, conf) {
  if (conf.queryParametersFilter === undefined || conf.queryParametersFilter === '') {
    return [];
  }
  const filterRegExp = new RegExp(conf.queryParametersFilter);
  return urlQueryParameters.map(keyValuePair => keyValuePair[0]).filter(param => filterRegExp.test(param));
}
function queryStringToKeep(urlQueryParameters, paramsToDelete) {
  const params = urlQueryParameters.filter(param => paramsToDelete.indexOf(param[0]) === -1).map(keyValue => "".concat(keyValue[0], "=").concat(keyValue[1]));
  if (params.length > 0) {
    return "?".concat(params.join('&'));
  } else {
    return '';
  }
}
function isDefaultBehavior(state) {
  return (state.urlCollectionMode === undefined || state.urlCollectionMode === UrlCollectionModes.full) && (state.queryParametersFilter === undefined || state.queryParametersFilter === '');
}
const noOpEvents = ['setemail', 'setemailhash', 'sethashedemail'];
class StateWrapper {
  constructor(state, eventBus) {
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "eventBus", void 0);
    this.data = StateWrapper.safeFiddle(state, eventBus);
    this.eventBus = eventBus;
  }
  static safeFiddle(newInfo, eventBus) {
    try {
      return fiddle(JSON.parse(JSON.stringify(newInfo)));
    } catch (e) {
      console.error(e);
      eventBus.emitErrorWithMessage('StateCombineWith', 'Error while extracting event data', e);
      return {};
    }
  }
  combineWith(newInfo) {
    return new StateWrapper(mergeObjects(this.data, newInfo), this.eventBus);
  }
  sendsPixel() {
    const source = isObject(this.data.eventSource) ? this.data.eventSource : {};
    const eventKeys = Object.keys(source).filter(objKey => objKey.toLowerCase() === 'eventname' || objKey.toLowerCase() === 'event');
    const eventKey = eventKeys && eventKeys.length >= 1 && eventKeys[0];
    const eventName = eventKey && trim(source[eventKey]);
    return !eventName || noOpEvents.indexOf(eventName.toLowerCase()) === -1;
  }
  asQuery() {
    var _state$decisionIds, _state$hashedEmail, _state$gppApplicableS;
    const state = this.data;
    // roughly add parameters in order of importance as the url might get truncated
    const builder = new QueryBuilder().addOptional('aid', state.appId).addOptional('did', state.distributorId).addOptional('se', onNonNull(state.eventSource, s => base64UrlEncode(JSON.stringify(s, replacer)))).addOptional('duid', state.liveConnectId).addOptional('tv', state.trackerVersion);
    if (nonNull(state.pageUrl)) {
      const [url, isPathRemoved, blockedParams] = collectUrl(state);
      builder.add('pu', url).addOptional('pu_rp', isPathRemoved ? '1' : undefined).add('pu_rqp', blockedParams.join(','));
    }
    builder.addOptional('ae', onNonNull(state.errorDetails, ed => base64UrlEncode(JSON.stringify(ed))));
    if (isArray(state.retrievedIdentifiers)) {
      state.retrievedIdentifiers.forEach(i => builder.add("ext_".concat(i.name), i.value));
    }
    if (isArray(state.hashesFromIdentifiers)) {
      state.hashesFromIdentifiers.forEach(h => builder.add('scre', "".concat(h.md5, ",").concat(h.sha1, ",").concat(h.sha256)));
    }
    builder.addOptional('li_did', (_state$decisionIds = state.decisionIds) === null || _state$decisionIds === void 0 ? void 0 : _state$decisionIds.join(',')).addOptional('e', (_state$hashedEmail = state.hashedEmail) === null || _state$hashedEmail === void 0 ? void 0 : _state$hashedEmail.join(',')).addOptional('us_privacy', state.usPrivacyString).addOptional('wpn', state.wrapperName).addOptional('gdpr', onNonNull(state.gdprApplies, v => v ? '1' : '0')).addOptional('gdpr_consent', state.gdprConsent).addOptional('refr', state.referrer).addOptional('gpp_s', state.gppString).addOptional('gpp_as', (_state$gppApplicableS = state.gppApplicableSections) === null || _state$gppApplicableS === void 0 ? void 0 : _state$gppApplicableS.join(',')).addOptional('cd', state.cookieDomain).addOptional('ic', encodeIdCookie(state.resolvedIdCookie), {
      stripEmpty: false
    }).addOptional('c', state.contextElements);
    return builder;
  }
}
function loadedDomain() {
  return document.domain || document.location && document.location.host || window && window.location && window.location.host || 'localhost';
}
function getReferrer() {
  let win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  return _safeGet(() => win.top.document.referrer);
}
function getPage() {
  let win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  const ancestorOrigins = _safeGet(() => win.location.ancestorOrigins) || [];
  const windows = [];
  let currentWindow = win;
  while (currentWindow !== top) {
    windows.push(currentWindow);
    currentWindow = currentWindow.parent;
  }
  windows.push(currentWindow);
  let detectedPageUrl;
  for (let i = windows.length - 1; i >= 0 && !detectedPageUrl; i--) {
    detectedPageUrl = _safeGet(() => windows[i].location.href);
    if (i !== 0) {
      if (!detectedPageUrl) detectedPageUrl = _safeGet(() => windows[i - 1].document.referrer);
      if (!detectedPageUrl) detectedPageUrl = ancestorOrigins[i - 1];
    }
  }
  return detectedPageUrl;
}
function getContextElements(privacyMode, contextSelectors, contextElementsLength) {
  if (privacyMode || !contextSelectors || contextSelectors === '' || !contextElementsLength) {
    return '';
  } else {
    const collectedElements = _collectElementsText(contextSelectors, contextElementsLength);
    return base64UrlEncode(collectedElements);
  }
}
function _collectElementsText(contextSelectors, contextElementsLength) {
  const collectedElements = window.document.querySelectorAll(contextSelectors);
  let collectedString = '';
  for (let i = 0; i < collectedElements.length; i++) {
    const nextElement = replaceEmailsWithHashes(collectedElements[i].outerHTML).stringWithoutRawEmails;
    const maybeCollectedString = collectedString + nextElement;
    if (encodedByteCount(maybeCollectedString) <= contextElementsLength) collectedString = maybeCollectedString;else return collectedString;
  }
  return collectedString;
}
function encodedByteCount(s) {
  // From: https://stackoverflow.com/questions/2219526/how-many-bytes-in-a-javascript-string
  return Math.ceil(new Blob([s]).size * 4 / 3.0);
}
function _safeGet(getter) {
  try {
    return getter();
  } catch (e) {
    return undefined;
  }
}
const enrichPage = state => ({
  ...state,
  pageUrl: getPage(),
  referrer: getReferrer(),
  contextElements: getContextElements(state.privacyMode, state.contextSelectors, state.contextElementsLength)
});
function enrichIdentifiers$1(storageHandler, eventBus) {
  return state => {
    try {
      return {
        ...state,
        ...getIdentifiers(parseIdentifiersToResolve(state.identifiersToResolve), storageHandler)
      };
    } catch (e) {
      eventBus.emitError('IdentifiersEnricher', e);
      return {
        ...state,
        retrievedIdentifiers: [],
        hashesFromIdentifiers: []
      };
    }
  };
}
function parseIdentifiersToResolve(identifiersToResolve) {
  let cookieNames = [];
  if (identifiersToResolve) {
    if (isArray(identifiersToResolve)) {
      cookieNames = identifiersToResolve;
    } else if (isString(identifiersToResolve)) {
      cookieNames = identifiersToResolve.split(',');
    }
  }
  for (let i = 0; i < cookieNames.length; i++) {
    cookieNames[i] = cookieNames[i].trim();
  }
  return cookieNames;
}
function getIdentifiers(cookieNames, storageHandler) {
  const identifiers = [];
  let hashes = [];
  for (let i = 0; i < cookieNames.length; i++) {
    const identifierName = cookieNames[i];
    const identifierValue = storageHandler.getCookie(identifierName) || storageHandler.getDataFromLocalStorage(identifierName);
    if (identifierValue) {
      const cookieAndHashes = replaceEmailsWithHashes(safeToString(identifierValue));
      identifiers.push({
        name: identifierName,
        value: cookieAndHashes.stringWithoutRawEmails
      });
      hashes = hashes.concat(cookieAndHashes.hashesFromOriginalString);
    }
  }
  return {
    retrievedIdentifiers: identifiers,
    hashesFromIdentifiers: deduplicateHashes(hashes)
  };
}
function deduplicateHashes(hashes) {
  const seen = new Set();
  const result = [];
  for (let i = 0; i < hashes.length; i++) {
    if (!seen.has(hashes[i].md5)) {
      result.push(hashes[i]);
      seen.add(hashes[i].md5);
    }
  }
  return result;
}
const enrichPrivacyMode = state => {
  var _state$gppApplicableS2;
  return {
    ...state,
    privacyMode: !!state.gdprApplies || ((_state$gppApplicableS2 = state.gppApplicableSections) !== null && _state$gppApplicableS2 !== void 0 ? _state$gppApplicableS2 : []).indexOf(2) > -1
  };
};
function removeInvalidPairs(config, eventBus) {
  if (config && config.appId && config.distributorId) {
    const distributorId = config.distributorId;
    delete config.distributorId;
    eventBus.emitError('AppIdAndDistributorIdPresent', new Error("Event contains both appId: ".concat(config.appId, " and distributorId: ").concat(distributorId, ". Ignoring distributorId")));
  }
  return config;
}
const ID_COOKIE_ATTR = 'idCookie';
class IdentityResolver {
  constructor(config, calls, eventBus) {
    var _nonNullConfig$privac, _nonNullConfig$gppApp;
    _defineProperty(this, "eventBus", void 0);
    _defineProperty(this, "calls", void 0);
    _defineProperty(this, "idexConfig", void 0);
    _defineProperty(this, "externalIds", void 0);
    _defineProperty(this, "source", void 0);
    _defineProperty(this, "publisherId", void 0);
    _defineProperty(this, "url", void 0);
    _defineProperty(this, "timeout", void 0);
    _defineProperty(this, "requestedAttributes", void 0);
    // Be careful, this object is mutable. In cases where temporary changes are needed
    // - e.g. adding parameters that are only valid for one single call - ensure to copy it
    _defineProperty(this, "query", void 0);
    _defineProperty(this, "privacyMode", void 0);
    _defineProperty(this, "resolvedIdCookie", void 0);
    _defineProperty(this, "generateIdCookie", void 0);
    _defineProperty(this, "peopleVerifiedId", void 0);
    _defineProperty(this, "pageUrl", void 0);
    const nonNullConfig = config || {
      identityResolutionConfig: {}
    };
    this.eventBus = eventBus;
    this.calls = calls;
    this.idexConfig = nonNullConfig.identityResolutionConfig || {};
    this.externalIds = nonNullConfig.retrievedIdentifiers || [];
    this.source = this.idexConfig.source || 'unknown';
    this.publisherId = this.idexConfig.publisherId || 'any';
    this.url = this.idexConfig.url || DEFAULT_IDEX_URL;
    this.timeout = this.idexConfig.ajaxTimeout || nonNullConfig.ajaxTimeout || DEFAULT_IDEX_AJAX_TIMEOUT;
    this.requestedAttributes = this.idexConfig.requestedAttributes || DEFAULT_REQUESTED_ATTRIBUTES;
    this.privacyMode = (_nonNullConfig$privac = nonNullConfig.privacyMode) !== null && _nonNullConfig$privac !== void 0 ? _nonNullConfig$privac : false;
    this.resolvedIdCookie = nonNullConfig.resolvedIdCookie;
    this.generateIdCookie = this.idexConfig.idCookieMode === 'generated';
    this.peopleVerifiedId = nonNullConfig.peopleVerifiedId;
    this.pageUrl = nonNullConfig.pageUrl;
    this.query = new QueryBuilder().addOptional('duid', nonNullConfig.peopleVerifiedId).addOptional('us_privacy', nonNullConfig.usPrivacyString).addOptional('gdpr', onNonNull(nonNullConfig.gdprApplies, v => v ? 1 : 0)).addOptional('gdpr_consent', nonNullConfig.gdprConsent).addOptional('did', nonNullConfig.distributorId).addOptional('gpp_s', nonNullConfig.gppString).addOptional('gpp_as', (_nonNullConfig$gppApp = nonNullConfig.gppApplicableSections) === null || _nonNullConfig$gppApp === void 0 ? void 0 : _nonNullConfig$gppApp.join(',')).addOptional('cd', nonNullConfig.cookieDomain).addOptional('ic', encodeIdCookie(nonNullConfig.resolvedIdCookie), {
      stripEmpty: false
    }).addOptional('pu', onNonNull(nonNullConfig.pageUrl, stripQueryAndPath));
    this.externalIds.forEach(retrievedIdentifier => {
      this.query.add(retrievedIdentifier.name, retrievedIdentifier.value);
    });
    this.requestedAttributes.forEach(requestedAttribute => {
      this.query.add('resolve', requestedAttribute);
    });
  }
  attributeResolutionAllowed(attribute) {
    if (attribute === 'uid2') {
      return !this.privacyMode;
    } else if (attribute === ID_COOKIE_ATTR) {
      // cannot be resolved server-side
      return false;
    } else {
      return true;
    }
  }
  filterParams(query) {
    return query.filteredCopy((key, value) => {
      if (key === 'resolve') {
        if (isString(value)) {
          return this.attributeResolutionAllowed(value);
        } else {
          return false;
        }
      } else {
        return true;
      }
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  enrichExtraIdentifiers(response, params) {
    const requestedAttributes = params.tuples.filter(_ref3 => {
      let [key] = _ref3;
      return key === 'resolve';
    }).map(_ref4 => {
      let [, value] = _ref4;
      return value;
    });
    function requested(attribute) {
      return requestedAttributes.indexOf(attribute) > -1;
    }
    const result = {
      ...response
    };
    if (requested(ID_COOKIE_ATTR)) {
      if (this.generateIdCookie && this.peopleVerifiedId) {
        result[ID_COOKIE_ATTR] = this.peopleVerifiedId;
      } else if (this.resolvedIdCookie) {
        result[ID_COOKIE_ATTR] = this.resolvedIdCookie;
      }
    }
    return result;
  }
  responseReceived(successCallback, params) {
    return (responseText, response) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let responseObj = {};
      if (responseText) {
        try {
          const responseJson = JSON.parse(responseText);
          if (isObject(responseJson)) {
            responseObj = responseJson;
          }
        } catch (ex) {
          console.error('Error parsing response', ex);
          this.eventBus.emitError('IdentityResolverParser', ex);
        }
      }
      const expiresAt = responseExpires(response);
      successCallback(this.enrichExtraIdentifiers(responseObj, params), {
        expiresAt
      });
    };
  }
  buildUrl(query) {
    return "".concat(this.url, "/").concat(this.source, "/").concat(this.publisherId).concat(this.filterParams(query).toQueryString());
  }
  getUrl(additionalParams) {
    const params = this.query.copy().addParamsMap(additionalParams !== null && additionalParams !== void 0 ? additionalParams : {});
    return this.buildUrl(params);
  }
  resolve(successCallback, errorCallback, additionalParams) {
    try {
      const params = this.query.copy().addParamsMap(additionalParams !== null && additionalParams !== void 0 ? additionalParams : {});
      this.calls.ajaxGet(this.buildUrl(params), this.responseReceived(successCallback, params), errorCallback, this.timeout);
    } catch (e) {
      console.error('IdentityResolve', e);
      if (errorCallback && isFunction(errorCallback)) {
        errorCallback(e);
      }
      if (this.eventBus) {
        this.eventBus.emitError('IdentityResolve', e);
      }
    }
  }
}
function responseExpires(response) {
  if (isObject(response) && 'getResponseHeader' in response && isFunction(response.getResponseHeader)) {
    const expiresHeader = response.getResponseHeader('expires');
    if (expiresHeader) {
      return new Date(expiresHeader);
    }
  }
}

// @ts-nocheck
function initBus(size) {
  if (typeof size === 'number' && size >= 0) {
    return new ReplayEmitter(size);
  } else {
    return new ReplayEmitter(5);
  }
}
function extendBusIfNeeded(bus) {
  if (isFunction(bus.emitErrorWithMessage) && isFunction(bus.emitError)) {
    return;
  }
  bus.emitErrorWithMessage = function (name, message) {
    let e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const wrappedError = wrapError(name, message, e);
    return bus.emit(ERRORS_CHANNEL, wrappedError);
  };
  bus.emitError = function (name, exception) {
    return bus.emitErrorWithMessage(name, exception.message, exception);
  };
}
function LocalEventBus() {
  let size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  return initBus(size);
}
function GlobalEventBus(name, size, errorCallback) {
  try {
    if (!window) {
      errorCallback(new Error('Bus can only be attached to the window, which is not present'));
    }
    if (window && !window[name]) {
      window[name] = initBus(size);
    }
    extendBusIfNeeded(window[name]);
    return window[name];
  } catch (e) {
    console.error('events.bus.init', e);
    errorCallback(e);
  }
}
function getAvailableBus(name) {
  const eventBus = window[name].eventBus || window[EVENT_BUS_NAMESPACE];
  extendBusIfNeeded(eventBus);
  return eventBus;
}
var eventBus = /*#__PURE__*/Object.freeze({
  __proto__: null,
  GlobalEventBus: GlobalEventBus,
  LocalEventBus: LocalEventBus,
  getAvailableBus: getAvailableBus
});
const TLD_CACHE_KEY = '_li_dcdm_c';
function determineHighestWritableDomain(storageHandler) {
  const cachedDomain = storageHandler.getCookie(TLD_CACHE_KEY);
  if (cachedDomain) {
    return cachedDomain;
  }
  const domain = loadedDomain();
  const arr = domain.split('.');
  for (let i = arr.length; i > 0; i--) {
    const newD = ".".concat(arr.slice(i - 1, arr.length).join('.'));
    storageHandler.setCookie(TLD_CACHE_KEY, newD, undefined, 'Lax', newD);
    if (storageHandler.getCookie(TLD_CACHE_KEY)) {
      return newD;
    }
  }
  return ".".concat(domain);
}
function enrichDomain(storageHandler) {
  return state => ({
    ...state,
    cookieDomain: determineHighestWritableDomain(storageHandler)
  });
}
const StorageStrategies = {
  cookie: 'cookie',
  localStorage: 'ls',
  none: 'none',
  // read-only
  disabled: 'disabled' // completely disabled
};

const enrichStorageStrategy = state => {
  const storageStrategy = state.privacyMode ? StorageStrategies.disabled : state.storageStrategy || StorageStrategies.cookie;
  return {
    ...state,
    storageStrategy
  };
};
const DEFAULT_DECISION_ID_COOKIE_EXPIRES = expiresInDays(30);
const DECISION_ID_QUERY_PARAM_NAME = 'li_did';
const DECISION_ID_COOKIE_NAMESPACE = 'lidids.';
const _onlyUnique = (value, index, self) => self.indexOf(value) === index;
const _nonEmpty = value => value && trim(value).length > 0;
function enrichDecisionIds(storageHandler, eventBus) {
  return state => {
    function addDecisionId(key) {
      if (key) {
        storageHandler.setCookie("".concat(DECISION_ID_COOKIE_NAMESPACE).concat(key), key, DEFAULT_DECISION_ID_COOKIE_EXPIRES, 'Lax', state.cookieDomain);
      }
    }
    function orElseEmpty(errorDescription, f) {
      try {
        return f();
      } catch (e) {
        eventBus.emitErrorWithMessage('DecisionsResolve', errorDescription, e);
        return [];
      }
    }
    const freshDecisions = orElseEmpty('Error while extracting new decision ids', () => {
      const extractedFreshDecisions = [].concat(state.pageUrl && getQueryParameter(state.pageUrl, DECISION_ID_QUERY_PARAM_NAME) || []);
      return extractedFreshDecisions.map(trim).filter(_nonEmpty).filter(isUUID).filter(_onlyUnique);
    });
    const storedDecisions = orElseEmpty('Error while retrieving stored decision ids', () => {
      const extractedStoredDecisions = storageHandler.findSimilarCookies(DECISION_ID_COOKIE_NAMESPACE);
      return extractedStoredDecisions.map(trim).filter(_nonEmpty).filter(isUUID);
    });
    freshDecisions.forEach(decision => {
      try {
        addDecisionId(decision);
      } catch (e) {
        eventBus.emitErrorWithMessage('DecisionsResolve', 'Error while storing new decision id', e);
      }
    });
    return {
      ...state,
      decisionIds: freshDecisions.concat(storedDecisions).filter(_onlyUnique)
    };
  };
}

// Borrowed from https://github.com/Kiosked/ulid
const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const ENCODING_LEN = ENCODING.length;
const TIME_MAX = Math.pow(2, 48) - 1;
const TIME_LEN = 10;
const RANDOM_LEN = 16;
const prng = detectPrng();
function createError(message) {
  const err = new Error(message);
  err.source = 'Ulid';
  return err;
}
function detectPrng() {
  const root = typeof window !== 'undefined' ? window : null;
  const browserCrypto = root && (root.crypto || root.msCrypto);
  if (browserCrypto) {
    return () => {
      const buffer = new Uint8Array(1);
      browserCrypto.getRandomValues(buffer);
      return buffer[0] / 0xff;
    };
  }
  return () => Math.random();
}
function encodeTime(now, len) {
  if (now > TIME_MAX) {
    throw createError('cannot encode time greater than ' + TIME_MAX);
  }
  let mod;
  let str = '';
  for (; len > 0; len--) {
    mod = now % ENCODING_LEN;
    str = ENCODING.charAt(mod) + str;
    now = (now - mod) / ENCODING_LEN;
  }
  return str;
}
function encodeRandom(len) {
  let str = '';
  for (; len > 0; len--) {
    str = randomChar() + str;
  }
  return str;
}
function randomChar() {
  let rand = Math.floor(prng() * ENCODING_LEN);
  if (rand === ENCODING_LEN) {
    rand = ENCODING_LEN - 1;
  }
  return ENCODING.charAt(rand);
}
// the factory to generate unique identifier based on time and current pseudorandom number
function ulid() {
  return encodeTime(Date.now(), TIME_LEN) + encodeRandom(RANDOM_LEN);
}
const NEXT_GEN_FP_NAME = '_lc2_fpi';
function enrichLiveConnectId(cache, storageHandler) {
  return state => {
    let liveConnectIdentifier;
    // reading the value will also repair any broken records
    const oldValue = cache.get(NEXT_GEN_FP_NAME);
    if (oldValue) {
      liveConnectIdentifier = oldValue.data;
    } else {
      const legacyValue = storageHandler.getCookie(NEXT_GEN_FP_NAME);
      if (legacyValue) {
        // backwards compatibility case. We have a cookie but no cache metadata.
        // We might overwrite a http cookie here. But this will be fixed with the next http request to cff.
        cache.set(NEXT_GEN_FP_NAME, legacyValue);
        liveConnectIdentifier = legacyValue;
      } else {
        var _cache$get;
        const newValue = "".concat(domainHash(state.cookieDomain), "--").concat(ulid()).toLocaleLowerCase();
        // will also set cookie. It will also later be extended by cookie bouncing in the cff.
        cache.set(NEXT_GEN_FP_NAME, newValue);
        // handle case when all storage backends are disabled
        liveConnectIdentifier = (_cache$get = cache.get(NEXT_GEN_FP_NAME)) === null || _cache$get === void 0 ? void 0 : _cache$get.data;
      }
    }
    if (liveConnectIdentifier) {
      // TODO: should we expose this to users even if the write failed?
      storageHandler.setDataInLocalStorage(PEOPLE_VERIFIED_LS_ENTRY, liveConnectIdentifier);
    }
    return {
      ...state,
      liveConnectId: liveConnectIdentifier,
      peopleVerifiedId: liveConnectIdentifier
    };
  };
}
const MAX_ERROR_FIELD_LENGTH = 120;
const defaultReturn = {
  errorDetails: {
    message: 'Unknown message',
    name: 'Unknown name'
  }
};
function _asInt(field) {
  try {
    const intValue = field * 1;
    return isNaN(intValue) ? undefined : intValue;
  } catch {}
}
function _truncate(value) {
  try {
    if (isString(value) && value.length && value.length > MAX_ERROR_FIELD_LENGTH) {
      return "".concat(value.substr(0, MAX_ERROR_FIELD_LENGTH), "...");
    } else {
      return "".concat(value);
    }
  } catch {}
}
function asErrorDetails(e) {
  if (isRecord(e)) {
    return {
      errorDetails: {
        message: _truncate(e.message) || '',
        name: _truncate(e.name) || '',
        stackTrace: _truncate(e.stack),
        lineNumber: _asInt(e.lineNumber),
        columnNumber: _asInt(e.columnNumber),
        fileName: _truncate(e.fileName)
      }
    };
  } else {
    return defaultReturn;
  }
}
function register(state, sender, eventBus) {
  try {
    eventBus.on(ERRORS_CHANNEL, error => {
      sender.sendPixel(new StateWrapper({
        ...state,
        ...asErrorDetails(error)
      }, eventBus));
    });
  } catch (e) {
    console.error('handlers.error.register', e);
  }
}
const noop$1 = () => undefined;
class WrappingContext {
  constructor(obj, name, eventBus) {
    _defineProperty(this, "obj", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "errors", void 0);
    _defineProperty(this, "eventBus", void 0);
    this.obj = obj;
    this.name = name;
    this.errors = [];
    this.eventBus = eventBus;
  }
  wrap(functionName) {
    var _this = this;
    if (isObject(this.obj)) {
      const member = this.obj[functionName];
      if (isFunction(member)) {
        return function () {
          try {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return member.call(_this.obj, ...args);
          } catch (e) {
            _this.eventBus.emitErrorWithMessage(_this.name, "Failed calling ".concat(functionName), e);
          }
        };
      }
    }
    this.errors.push(functionName);
    return noop$1;
  }
  reportErrors() {
    if (this.errors.length > 0) {
      this.eventBus.emitErrorWithMessage(this.name, "The functions '".concat(JSON.stringify(this.errors), "' were not provided"));
    }
  }
}
const noop = () => undefined;
function wrapRead(wrapper, storageStrategy, functionName) {
  return strEqualsIgnoreCase(storageStrategy, StorageStrategies.disabled) ? noop : wrapper.wrap(functionName);
}
function wrapWrite(wrapper, storageStrategy, functionName) {
  return strEqualsIgnoreCase(storageStrategy, StorageStrategies.none) ? noop : wrapRead(wrapper, storageStrategy, functionName);
}
class WrappedReadOnlyStorageHandler {
  constructor(storageStrategy, wrapper) {
    _defineProperty(this, "minimalFunctions", void 0);
    this.minimalFunctions = {
      getCookie: wrapRead(wrapper, storageStrategy, 'getCookie'),
      getDataFromLocalStorage: wrapRead(wrapper, storageStrategy, 'getDataFromLocalStorage'),
      localStorageIsEnabled: wrapWrite(wrapper, storageStrategy, 'localStorageIsEnabled')
    };
  }
  static make(storageStrategy, externalStorageHandler, eventBus) {
    const wrapper = new WrappingContext(externalStorageHandler, 'ReadOnlyStorageHandler', eventBus);
    const handler = new WrappedReadOnlyStorageHandler(storageStrategy, wrapper);
    wrapper.reportErrors();
    return handler;
  }
  localStorageIsEnabled() {
    return !!this.minimalFunctions.localStorageIsEnabled();
  }
  getCookie(key) {
    return this.minimalFunctions.getCookie(key) || null;
  }
  getDataFromLocalStorage(key) {
    return this.minimalFunctions.getDataFromLocalStorage(key) || null;
  }
}
class WrappedStorageHandler extends WrappedReadOnlyStorageHandler {
  constructor(storageStrategy, wrapper) {
    super(storageStrategy, wrapper);
    _defineProperty(this, "storageStrategy", void 0);
    _defineProperty(this, "functions", void 0);
    this.storageStrategy = storageStrategy;
    this.functions = {
      setCookie: wrapWrite(wrapper, storageStrategy, 'setCookie'),
      removeDataFromLocalStorage: wrapWrite(wrapper, storageStrategy, 'removeDataFromLocalStorage'),
      setDataInLocalStorage: wrapWrite(wrapper, storageStrategy, 'setDataInLocalStorage'),
      findSimilarCookies: wrapRead(wrapper, storageStrategy, 'findSimilarCookies')
    };
  }
  static make(storageStrategy, externalStorageHandler, eventBus) {
    const wrapper = new WrappingContext(externalStorageHandler, 'StorageHandler', eventBus);
    const handler = new WrappedStorageHandler(storageStrategy, wrapper);
    wrapper.reportErrors();
    return handler;
  }
  setCookie(key, value, expires, sameSite, domain) {
    this.functions.setCookie(key, value, expires, sameSite, domain);
  }
  setDataInLocalStorage(key, value) {
    this.functions.setDataInLocalStorage(key, value);
  }
  removeDataFromLocalStorage(key) {
    this.functions.removeDataFromLocalStorage(key);
  }
  findSimilarCookies(substring) {
    return this.functions.findSimilarCookies(substring) || [];
  }
}
const DEFAULT_COOKIE_EXPIRATION_DAYS = 730;
class ParseError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ParseError';
  }
}
class StorageHandlerBackedCache {
  constructor(opts) {
    _defineProperty(this, "handler", void 0);
    _defineProperty(this, "cookieDomain", void 0);
    _defineProperty(this, "eventBus", void 0);
    this.handler = opts.storageHandler;
    this.cookieDomain = opts.cookieDomain;
    this.eventBus = opts.eventBus;
  }
  deleteCookie(key) {
    this.handler.setCookie(key, '', new Date(0), 'Lax', this.cookieDomain);
  }
  // layout: { w: writtenAt in millis, e? : expiresAt in millis }
  parseMetaRecord(serialized) {
    const meta = JSON.parse(serialized);
    if (!isObject(meta)) {
      throw new ParseError('Meta record is not an object');
    }
    let expiresAt;
    if ('e' in meta) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      expiresAt = new Date(meta.e);
      if (isNaN(expiresAt.getTime())) {
        throw new ParseError('Invalid expiresAt');
      }
    }
    if (!('w' in meta)) {
      throw new ParseError('Missing writtenAt');
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const writtenAt = new Date(meta.w);
    if (isNaN(writtenAt.getTime())) {
      throw new ParseError('Invalid writtenAt');
    }
    return {
      expiresAt,
      writtenAt
    };
  }
  serializeMetaRecord(meta) {
    let expiresAtMillis;
    if (meta.expiresAt) {
      expiresAtMillis = meta.expiresAt.getTime();
    }
    return JSON.stringify({
      w: meta.writtenAt.getTime(),
      e: expiresAtMillis
    });
  }
  getCookieRecord(key, metaRecordKey) {
    const metaRecord = this.handler.getCookie(metaRecordKey);
    if (!metaRecord || metaRecord.length === 0) {
      return null;
    }
    let meta;
    try {
      meta = this.parseMetaRecord(metaRecord);
    } catch (e) {
      this.eventBus.emitErrorWithMessage('Cache', 'Failed reading meta from cookies', e);
      // delete this so we don't keep trying to read it
      this.deleteCookie(key);
      this.deleteCookie(metaRecordKey);
      return null;
    }
    const expiresAt = meta.expiresAt;
    if (expiresAt && expiresAt.getTime() <= Date.now()) {
      // expired. No need to clean up as the browser will do it for us
      return null;
    }
    const data = this.handler.getCookie(key);
    if (!data) {
      return null;
    }
    return {
      data,
      meta
    };
  }
  getLSRecord(key, metaRecordKey) {
    const metaRecord = this.handler.getDataFromLocalStorage(metaRecordKey);
    if (!metaRecord || metaRecord.length === 0) {
      return null;
    }
    let meta;
    try {
      meta = this.parseMetaRecord(metaRecord);
    } catch (e) {
      this.eventBus.emitErrorWithMessage('Cache', 'Failed reading meta from ls', e);
      this.handler.removeDataFromLocalStorage(key);
      this.handler.removeDataFromLocalStorage(metaRecordKey);
      return null;
    }
    const expiresAt = meta.expiresAt;
    if (expiresAt && expiresAt.getTime() <= Date.now()) {
      // expired.
      this.handler.removeDataFromLocalStorage(key);
      this.handler.removeDataFromLocalStorage(metaRecordKey);
      return null;
    }
    const data = this.handler.getDataFromLocalStorage(key);
    if (!data) {
      return null;
    }
    return {
      data,
      meta
    };
  }
  get(key) {
    const metaRecordKey = metaKey(key);
    const cookieRecord = this.getCookieRecord(key, metaRecordKey);
    const lsRecord = this.getLSRecord(key, metaRecordKey);
    if (cookieRecord && lsRecord) {
      // comparing dates with getTime() because Date objects are not equal
      if (cookieRecord.meta.writtenAt.getTime() === lsRecord.meta.writtenAt.getTime()) {
        return cookieRecord;
      } else if (cookieRecord.meta.writtenAt > lsRecord.meta.writtenAt) {
        // cookie record is newer. Update ls record
        this.handler.setDataInLocalStorage(key, cookieRecord.data);
        this.handler.setDataInLocalStorage(metaRecordKey, this.serializeMetaRecord(cookieRecord.meta));
        return cookieRecord;
      } else {
        // ls record is newer. Update cookie record
        this.handler.setCookie(key, lsRecord.data, lsRecord.meta.expiresAt, 'Lax', this.cookieDomain);
        this.handler.setCookie(metaRecordKey, this.serializeMetaRecord(lsRecord.meta), lsRecord.meta.expiresAt, 'Lax', this.cookieDomain);
        return lsRecord;
      }
    } else if (cookieRecord) {
      // only cookie record exists. Write to ls
      this.handler.setDataInLocalStorage(key, cookieRecord.data);
      this.handler.setDataInLocalStorage(metaRecordKey, this.serializeMetaRecord(cookieRecord.meta));
      return cookieRecord;
    } else if (lsRecord) {
      // only ls record exists. Write to cookie
      this.handler.setCookie(key, lsRecord.data, lsRecord.meta.expiresAt, 'Lax', this.cookieDomain);
      this.handler.setCookie(metaRecordKey, this.serializeMetaRecord(lsRecord.meta), lsRecord.meta.expiresAt, 'Lax', this.cookieDomain);
      return lsRecord;
    } else {
      return null;
    }
  }
  set(key, value, expires) {
    const metaRecordKey = metaKey(key);
    const metaRecord = this.serializeMetaRecord({
      writtenAt: new Date(),
      expiresAt: expires
    });
    // set in ls
    this.handler.setDataInLocalStorage(key, value);
    this.handler.setDataInLocalStorage(metaRecordKey, metaRecord);
    // needs to be set as cookies will be session cookies otherwise. Try to make them live as long as possible
    const cookieExpires = expires || expiresInDays(DEFAULT_COOKIE_EXPIRATION_DAYS);
    // set in cookie
    this.handler.setCookie(key, value, cookieExpires, 'Lax', this.cookieDomain);
    this.handler.setCookie(metaRecordKey, metaRecord, cookieExpires, 'Lax', this.cookieDomain);
  }
}
function metaKey(baseKey) {
  return "".concat(baseKey, "_meta");
}
const empty = () => undefined;
function privacyCheck(wrapper, privacyMode, functionName) {
  return privacyMode ? empty : wrapper.wrap(functionName);
}
class WrappedCallHandler {
  constructor(externalCallHandler, eventBus, privacyMode) {
    _defineProperty(this, "functions", void 0);
    const wrapper = new WrappingContext(externalCallHandler, 'CallHandler', eventBus);
    this.functions = {
      ajaxGet: privacyCheck(wrapper, privacyMode, 'ajaxGet'),
      pixelGet: privacyCheck(wrapper, privacyMode, 'pixelGet')
    };
    wrapper.reportErrors();
  }
  ajaxGet(url, onSuccess, onError, timeout) {
    this.functions.ajaxGet(url, onSuccess, onError, timeout);
  }
  pixelGet(url, onLoad) {
    this.functions.pixelGet(url, onLoad);
  }
}
function enrichIdCookie(storageHandler) {
  return state => {
    var _state$idCookie, _state$idCookie2, _state$idCookie3, _state$idCookie4;
    if (((_state$idCookie = state.idCookie) === null || _state$idCookie === void 0 ? void 0 : _state$idCookie.strategy) === 'cookie' && typeof ((_state$idCookie2 = state.idCookie) === null || _state$idCookie2 === void 0 ? void 0 : _state$idCookie2.name) === 'string') {
      return {
        ...state,
        resolvedIdCookie: storageHandler.getCookie(state.idCookie.name)
      };
    } else if (((_state$idCookie3 = state.idCookie) === null || _state$idCookie3 === void 0 ? void 0 : _state$idCookie3.strategy) === 'localStorage' && typeof ((_state$idCookie4 = state.idCookie) === null || _state$idCookie4 === void 0 ? void 0 : _state$idCookie4.name) === 'string') {
      return {
        ...state,
        resolvedIdCookie: storageHandler.getDataFromLocalStorage(state.idCookie.name)
      };
    } else {
      return state;
    }
  };
}
const hemStore = {};
function pushSingleEvent(event, pixelClient, enrichedState, eventBus) {
  if (!event || !isObject(event)) {
    // @ts-ignore
    eventBus.emitErrorWithMessage('EventNotAnObject', 'Received event was not an object', new Error(event));
  } else if ('config' in event) {
    eventBus.emitErrorWithMessage('StrayConfig', 'Received a config after LC has already been initialised', new Error(JSON.stringify(event)));
  } else {
    const wrapper = new StateWrapper(enrichedState, eventBus);
    const combined = wrapper.combineWith({
      eventSource: event
    });
    hemStore.hashedEmail = hemStore.hashedEmail || combined.data.hashedEmail;
    const withHemStore = mergeObjects({
      eventSource: event
    }, hemStore);
    const onPreSend = () => eventBus.emit(PRELOAD_PIXEL, '0');
    const onLoad = () => eventBus.emit(PIXEL_SENT_PREFIX, enrichedState);
    pixelClient.sendAjax(wrapper.combineWith(withHemStore), {
      onPreSend,
      onLoad
    });
  }
}
function configMatcher(previousConfig, newConfig) {
  const equalConfigs = previousConfig.appId === newConfig.appId && previousConfig.wrapperName === newConfig.wrapperName && previousConfig.collectorUrl === newConfig.collectorUrl;
  if (!equalConfigs) {
    return {
      appId: [previousConfig.appId, newConfig.appId],
      wrapperName: [previousConfig.wrapperName, newConfig.wrapperName],
      collectorUrl: [previousConfig.collectorUrl, newConfig.collectorUrl]
    };
  }
}
function processArgs(args, pixelClient, enrichedState, eventBus) {
  try {
    args.forEach(arg => {
      const event = arg;
      if (isArray(event)) {
        event.forEach(e => pushSingleEvent(e, pixelClient, enrichedState, eventBus));
      } else {
        pushSingleEvent(event, pixelClient, enrichedState, eventBus);
      }
    });
  } catch (e) {
    console.error('Error sending events', e);
    eventBus.emitErrorWithMessage('LCPush', 'Failed sending an event', e);
  }
}
function getInitializedLiveConnect(liveConnectConfig) {
  try {
    // @ts-ignore
    if (window && window[liveConnectConfig.globalVarName] && window[liveConnectConfig.globalVarName].ready) {
      // @ts-ignore
      const mismatchedConfig = window[liveConnectConfig.globalVarName].config && configMatcher(window[liveConnectConfig.globalVarName].config, liveConnectConfig);
      if (mismatchedConfig) {
        const error = new Error();
        error.name = 'ConfigSent';
        error.message = 'Additional configuration received';
        // @ts-ignore
        const eventBus = getAvailableBus(liveConnectConfig.globalVarName);
        // @ts-ignore
        window[liveConnectConfig.globalVarName].eventBus = eventBus;
        eventBus.emitErrorWithMessage('LCDuplication', JSON.stringify(mismatchedConfig), error);
      }
      // @ts-ignore
      return window[liveConnectConfig.globalVarName];
    }
  } catch (e) {
    console.error('Could not initialize error bus');
  }
}
// @ts-ignore
function standardInitialization(liveConnectConfig, externalStorageHandler, externalCallHandler, eventBus) {
  try {
    // TODO: proper config validation
    const validLiveConnectConfig = {
      ...removeInvalidPairs(liveConnectConfig, eventBus),
      identifiersToResolve: liveConnectConfig.identifiersToResolve || [],
      contextSelectors: liveConnectConfig.contextSelectors || '',
      contextElementsLength: liveConnectConfig.contextElementsLength || 0
    };
    const stateWithStorage = enrichPage(enrichStorageStrategy(enrichPrivacyMode(validLiveConnectConfig)));
    const callHandler = new WrappedCallHandler(externalCallHandler, eventBus, stateWithStorage.privacyMode);
    const storageHandler = WrappedStorageHandler.make(stateWithStorage.storageStrategy, externalStorageHandler, eventBus);
    const stateWithDomain = enrichDomain(storageHandler)(stateWithStorage);
    const cache = new StorageHandlerBackedCache({
      storageHandler,
      eventBus,
      cookieDomain: stateWithDomain.cookieDomain
    });
    const enrichedState = enrichIdCookie(storageHandler)(enrichLiveConnectId(cache, storageHandler)(enrichDecisionIds(storageHandler, eventBus)(enrichIdentifiers$1(storageHandler, eventBus)(stateWithDomain))));
    const pixelSender = new PixelSender({
      collectorUrl: validLiveConnectConfig.collectorUrl,
      ajaxTimeout: validLiveConnectConfig.ajaxTimeout,
      eventBus,
      callHandler
    });
    register(enrichedState, pixelSender, eventBus);
    const resolver = new IdentityResolver(enrichedState, callHandler, eventBus);
    const _push = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return processArgs(args, pixelSender, enrichedState, eventBus);
    };
    return {
      push: _push,
      fire: () => _push({}),
      peopleVerifiedId: enrichedState.peopleVerifiedId,
      ready: true,
      resolve: resolver.resolve.bind(resolver),
      resolutionCallUrl: resolver.getUrl.bind(resolver),
      config: validLiveConnectConfig,
      eventBus,
      storageHandler,
      cache
    };
  } catch (x) {
    console.error(x);
    eventBus.emitErrorWithMessage('LCConstruction', 'Failed to build LC', x);
  }
}
function initializeWithoutGlobalName$1(liveConnectConfig, externalStorageHandler, externalCallHandler, eventBus) {
  const lc = standardInitialization(liveConnectConfig, externalStorageHandler, externalCallHandler, eventBus);
  window.liQ_instances = window.liQ_instances || [];
  window.liQ_instances.push(lc);
  return lc;
}
function initializeWithGlobalName$1(liveConnectConfig, externalStorageHandler, externalCallHandler, eventBus) {
  // @ts-ignore
  const queue = window[liveConnectConfig.globalVarName] || [];
  const lc = getInitializedLiveConnect(liveConnectConfig) || standardInitialization(liveConnectConfig, externalStorageHandler, externalCallHandler, eventBus) || queue;
  if (isArray(queue)) {
    for (let i = 0; i < queue.length; i++) {
      lc.push(queue[i]);
    }
  }
  // @ts-ignore
  window[lc.config.globalVarName] = lc;
  window.liQ_instances = window.liQ_instances || [];
  // @ts-ignore
  if (window.liQ_instances.filter(i => i.config.globalVarName === lc.config.globalVarName).length === 0) {
    window.liQ_instances.push(lc);
  }
  return lc;
}
function StandardLiveConnect$1(liveConnectConfig, externalStorageHandler, externalCallHandler, externalEventBus) {
  const configuration = isObject(liveConnectConfig) && liveConnectConfig || {};
  const eventBus = externalEventBus || LocalEventBus();
  let lc;
  try {
    lc = configuration.globalVarName ? initializeWithGlobalName$1(configuration, externalStorageHandler, externalCallHandler, eventBus) : initializeWithoutGlobalName$1(configuration, externalStorageHandler, externalCallHandler, eventBus);
  } catch (e) {
    console.error(e);
    eventBus.emitErrorWithMessage('LCConstruction', 'Failed to build LC', e);
  }
  // @ts-ignore
  return lc;
}
function enrichPeopleVerifiedId(storageHandler, eventBus) {
  return state => {
    try {
      return {
        ...state,
        peopleVerifiedId: state.peopleVerifiedId || storageHandler.getDataFromLocalStorage(PEOPLE_VERIFIED_LS_ENTRY) || undefined
      };
    } catch (e) {
      eventBus.emitError('PeopleVerifiedEnrich', e);
      return state;
    }
  };
}
function enrichIdentifiers(storageHandler, eventBus) {
  return state => {
    try {
      return {
        ...state,
        retrievedIdentifiers: resolveIdentifiers(state.identifiersToResolve, storageHandler)
      };
    } catch (e) {
      eventBus.emitError('IdentifiersEnrich', e);
      return {
        ...state,
        retrievedIdentifiers: []
      };
    }
  };
}
function resolveIdentifiers(identifiersToResolve, storageHandler) {
  const cookieNames = isArray(identifiersToResolve) ? identifiersToResolve : safeToString(identifiersToResolve).split(',');
  const identifiers = [];
  for (let i = 0; i < cookieNames.length; i++) {
    const identifierName = trim(cookieNames[i]);
    const identifierValue = storageHandler.getCookie(identifierName) || storageHandler.getDataFromLocalStorage(identifierName);
    if (identifierValue && !containsEmailField(safeToString(identifierValue)) && !isEmail(safeToString(identifierValue))) {
      identifiers.push({
        name: identifierName,
        value: safeToString(identifierValue)
      });
    }
  }
  return identifiers;
}

// @ts-ignore
function _minimalInitialization(liveConnectConfig, externalStorageHandler, externalCallHandler, eventBus, push) {
  try {
    const validLiveConnectConfig = {
      ...removeInvalidPairs(liveConnectConfig, eventBus),
      identifiersToResolve: liveConnectConfig.identifiersToResolve || []
    };
    const stateWithStorage = enrichStorageStrategy(enrichPrivacyMode(validLiveConnectConfig));
    const storageHandler = WrappedReadOnlyStorageHandler.make(stateWithStorage.storageStrategy, externalStorageHandler, eventBus);
    const callHandler = new WrappedCallHandler(externalCallHandler, eventBus, stateWithStorage.privacyMode);
    const enrichedState = enrichIdentifiers(storageHandler, eventBus)(enrichIdCookie(storageHandler)(enrichPeopleVerifiedId(storageHandler, eventBus)(stateWithStorage)));
    const resolver = new IdentityResolver(enrichedState, callHandler, eventBus);
    return {
      push: arg => push(arg),
      fire: () => push({}),
      peopleVerifiedId: enrichedState.peopleVerifiedId,
      ready: true,
      resolve: resolver.resolve.bind(resolver),
      resolutionCallUrl: resolver.getUrl.bind(resolver),
      config: validLiveConnectConfig,
      eventBus,
      // @ts-ignore
      storageHandler
    };
  } catch (x) {
    console.error(x);
  }
}
function initializeWithoutGlobalName(liveConnectConfig, externalStorageHandler, externalCallHandler, eventBus) {
  const lc = _minimalInitialization(liveConnectConfig, externalStorageHandler, externalCallHandler, eventBus, () => {});
  window.liQ_instances = window.liQ_instances || [];
  window.liQ_instances.push(lc);
  return lc;
}
function initializeWithGlobalName(liveConnectConfig, externalStorageHandler, externalCallHandler, eventBus) {
  // @ts-ignore
  const queue = window[liveConnectConfig.globalVarName] = window[liveConnectConfig.globalVarName] || [];
  const push = queue.push.bind(queue);
  const lc = _minimalInitialization(liveConnectConfig, externalStorageHandler, externalCallHandler, eventBus, push);
  window.liQ_instances = window.liQ_instances || [];
  // @ts-ignore
  if (window.liQ_instances.filter(i => i.config.globalVarName === lc.config.globalVarName).length === 0) {
    window.liQ_instances.push(lc);
  }
  return lc;
}
function MinimalLiveConnect$1(liveConnectConfig, externalStorageHandler, externalCallHandler, externalEventBus) {
  const configuration = isObject(liveConnectConfig) && liveConnectConfig || {};
  const eventBus = externalEventBus || LocalEventBus();
  try {
    return configuration.globalVarName ? initializeWithGlobalName(configuration, externalStorageHandler, externalCallHandler, eventBus) : initializeWithoutGlobalName(configuration, externalStorageHandler, externalCallHandler, eventBus);
  } catch (x) {
    console.error(x);
  }
  // @ts-ignore
  return {};
}
function LiveConnect$1(liveConnectConfig, externalStorageHandler, externalCallHandler, mode, externalEventBus) {
  const minimalMode = mode === 'minimal';
  const bus = externalEventBus || LocalEventBus();
  const configuration = isObject(liveConnectConfig) && liveConnectConfig || {};
  const initializationFunction = minimalMode ? MinimalLiveConnect$1 : StandardLiveConnect$1;
  return initializationFunction(configuration, externalStorageHandler, externalCallHandler, bus);
}

// upcasted versions of the internal APIs
const LiveConnect = LiveConnect$1;
const StandardLiveConnect = StandardLiveConnect$1;
const MinimalLiveConnect = MinimalLiveConnect$1;

export { LiveConnect, MinimalLiveConnect, StandardLiveConnect, consts, eventBus };
